import Vue from 'vue';
import { isString, camelCase, isObject, snakeCase, find, get as get$1, some, trim, isFunction, cloneDeep, assign } from 'lodash';
import tinykeys from 'tinykeys';
import { VALUE_ESCAPE } from 'keycode-js';
import { createPopper } from '@popperjs/core';
import PopupManager from '@kdocs/kdesign-vue/lib/utils/popup/popup-manager';
import { fromEmitter } from 'sub-events/ext';
import { initSizeTheme, setSizeTheme, getSizeTheme } from '@ksxz/size-theme';
import Input from 'element-ui/lib/input';
import Popover from 'element-ui/lib/popover';
import Link from 'element-ui/lib/link';
import Button from 'element-ui/lib/button';
import Checkbox from 'element-ui/lib/checkbox';
import Scrollbar from 'element-ui/lib/scrollbar';
import 'element-ui/lib/theme-chalk/input.css';
import 'element-ui/lib/theme-chalk/popover.css';
import 'element-ui/lib/theme-chalk/link.css';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/checkbox.css';
import 'element-ui/lib/theme-chalk/icon.css';
import 'element-ui/lib/theme-chalk/scrollbar.css';
import '@kdocs/kdesign-theme/default.css';
import '@kdocs/kdesign-theme/dark.css';
import '@kdocs/kdesign-icons-vue/styles/index.css';
import Tooltip from '@kdocs/kdesign-vue/lib/tooltip';
import '@kdocs/kdesign-vue/lib/theme-chalk/tooltip.css';
import Loading from '@kdocs/kdesign-vue/lib/loading';
import '@kdocs/kdesign-vue/lib/theme-chalk/loading.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import AmIcon from '@ksxz/amui/lib/icon';
import '@ksxz/amui/lib/icon/style.css';
import { VueContext } from 'vue-context';
import 'vue-context/dist/css/vue-context.css';
import { Prop, Component, Vue as Vue$1, Inject, Ref, Mixins, Watch, Provide } from 'vue-property-decorator';
import dayjs from 'dayjs';
import get from 'lodash/get';
import Url from 'url-parse';
import { generateApplication, generateServices } from '@ksxz/gateway-conf';
import { KsGateway } from '@ksxz/gateway';
import locale$1, { t as t$1 } from '@ksxz/user-card/lib/locale';
export { default as userCardLocale } from '@ksxz/user-card/lib/locale';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import 'query-string';
import { createApiClient } from '@ksxz/api-client';
import { axios as axios$1 } from '@ksxz/axios';
import cookies from 'js-cookie';
import botSvg from '@ksxz/user-card/lib/assets/img/bot.svg';
import { Copy, Pen, Eye, EyeClose } from '@kdocs/kdesign-icons-vue';
import Dialog$1 from '@kdocs/kdesign-vue/lib/dialog';
import '@kdocs/kdesign-vue/lib/theme-chalk/dialog.css';
import Button$1 from '@kdocs/kdesign-vue/lib/button';
import '@kdocs/kdesign-vue/lib/theme-chalk/button.css';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

class BasePopper {
}

var eventemitter3 = {exports: {}};

(function (module) {

  var has = Object.prototype.hasOwnProperty,
    prefix = '~';

  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @private
   */
  function Events() {}

  //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //
  if (Object.create) {
    Events.prototype = Object.create(null);

    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
  }

  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @private
   */
  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }

  /**
   * Add a listener for a given event.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} context The context to invoke the listener with.
   * @param {Boolean} once Specify if the listener is a one-time listener.
   * @returns {EventEmitter}
   * @private
   */
  function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') {
      throw new TypeError('The listener must be a function');
    }
    var listener = new EE(fn, context || emitter, once),
      evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }

  /**
   * Clear event by name.
   *
   * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
   * @param {(String|Symbol)} evt The Event name.
   * @private
   */
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
  }

  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @public
   */
  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }

  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @public
   */
  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
      events,
      name;
    if (this._eventsCount === 0) return names;
    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }
    return names;
  };

  /**
   * Return the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Array} The registered listeners.
   * @public
   */
  EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event,
      handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [handlers.fn];
    for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
      ee[i] = handlers[i].fn;
    }
    return ee;
  };

  /**
   * Return the number of listeners listening to a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Number} The number of listeners.
   * @public
   */
  EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event,
      listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
  };

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @public
   */
  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;
    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }
      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }
      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
        j;
      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;
          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;
          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;
          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;
          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }
    return true;
  };

  /**
   * Add a listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
  };

  /**
   * Add a one-time listener for a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn The listener function.
   * @param {*} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
  };

  /**
   * Remove the listeners of a given event.
   *
   * @param {(String|Symbol)} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {*} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      }

      //
      // Reset the array, or remove it completely if we have no more listeners.
      //
      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this, evt);
    }
    return this;
  };

  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {(String|Symbol)} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @public
   */
  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt]) clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };

  //
  // Alias methods names because people roll like that.
  //
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  //
  // Expose the prefix.
  //
  EventEmitter.prefixed = prefix;

  //
  // Allow `EventEmitter` to be imported as module namespace.
  //
  EventEmitter.EventEmitter = EventEmitter;

  //
  // Expose the module.
  //
  {
    module.exports = EventEmitter;
  }
})(eventemitter3);

const e = new eventemitter3.exports.EventEmitter();
const closePopperBus = fromEmitter(e, 'closePopperBus');

/**
 * 基于bus来管理弹出层，方便统一关闭
 */
class PopperManager {
    constructor() {
        return PopperManager._INSTANCE;
    }
    /**
     * 注册弹出层关闭方法
     * @param type 弹出层类型
     * @param close 关闭方法
     * @returns {Subscription} 一个订阅器，一定要确保在组件卸载时通过sub.cancel()取消订阅
     */
    register(type, close) {
        return closePopperBus.subscribe((data) => {
            const { reason, type: closeType, includes, excludes } = data;
            const shouldClose = type === closeType || (includes === null || includes === void 0 ? void 0 : includes.includes(type)) || (!includes && !(excludes === null || excludes === void 0 ? void 0 : excludes.includes(type)));
            if (shouldClose) {
                close();
                console.log(`popper(${type}) cloased (reason:${reason})`);
            }
        });
    }
    /**
     * 关闭指定弹出层
     * 关闭参数匹配顺序：
     * 1. type - 精确匹配类型
     * 2. includes - 包含指定类型
     * 3. excludes - 不包含指定类型
     * @param data 关闭参数
     */
    close(data) {
        closePopperBus.emit(data);
    }
    closeAll(reason) {
        this.close({ reason });
    }
}
PopperManager._INSTANCE = new PopperManager();
var PopperManager$1 = new PopperManager();

var EPopperType;
(function (EPopperType) {
    // 头像菜单
    EPopperType["AVATAR_MENU"] = "AVATAR_MENU";
    // emoji选择器/最近使用emoji
    EPopperType["EMOJI_POPPER"] = "EMOJI_POPPER";
    // 联系人卡片
    EPopperType["USER_CARD"] = "USER_CARD";
    // 会话工具栏下拉菜单
    EPopperType["CHAT_DROPDOWN"] = "CHAT_DROPDOWN";
    // 待办日期选择器
    EPopperType["TODO_DATE_PICKER"] = "TODO_DATE_PICKER";
})(EPopperType || (EPopperType = {}));

// 文档类型
var EDocType;
(function (EDocType) {
    EDocType[EDocType["NONE"] = -1] = "NONE";
    EDocType[EDocType["NORMAL"] = 0] = "NORMAL";
    EDocType[EDocType["NOTE"] = 1] = "NOTE";
    EDocType[EDocType["DBT"] = 2] = "DBT";
})(EDocType || (EDocType = {}));
var EUserCardType;
(function (EUserCardType) {
    EUserCardType["NORMAL"] = "NORMAL";
    EUserCardType["ROBOT"] = "ROBOT";
})(EUserCardType || (EUserCardType = {}));

// 字号模式，默认为 standard
var EFontSizeMode;
(function (EFontSizeMode) {
    EFontSizeMode["STANDARD"] = "standard";
    EFontSizeMode["MEDIUM"] = "medium";
    EFontSizeMode["LARGE"] = "large";
    EFontSizeMode["X_LARGE"] = "x-large";
})(EFontSizeMode || (EFontSizeMode = {}));
var ESizeTheme;
(function (ESizeTheme) {
    ESizeTheme["SIZE_PRIMARY_TITLE"] = "--size-user-card-size-theme-primary-title";
    ESizeTheme["SIZE_SUB_TITLE"] = "--size-user-card-size-theme-sub-title";
    ESizeTheme["SIZE_ICON_SIZE"] = "--size-user-card-size-theme-icon-size";
    ESizeTheme["SIZE_CHAT_TITLE"] = "--size-user-card-size-theme-chat-title";
    ESizeTheme["SIZE_LIST_ICON"] = "--size-user-card-size-theme-list-icon";
    ESizeTheme["SIZE_PRIMARY_ICON"] = "--size-user-card-size-theme-primary-icon";
    ESizeTheme["SIZE_DEL_TAG_WIDTH"] = "--size-user-card-size-theme-del-tag-w";
    ESizeTheme["SIZE_EXT_TAG_WIDTH"] = "--size-user-card-size-theme-ext-tag-w";
    ESizeTheme["SIZE_TAG_HEIGHT"] = "--size-user-card-size-theme-tag-h";
    ESizeTheme["SIZE_FRAME_SIZE"] = "--size-user-card-size-theme-frame-size";
})(ESizeTheme || (ESizeTheme = {}));

const sizeStandard = {
    name: 'fontSizeStandard',
    description: '标准字号调节',
    size: {
        [ESizeTheme.SIZE_PRIMARY_TITLE]: '14px',
        [ESizeTheme.SIZE_SUB_TITLE]: '12px',
        [ESizeTheme.SIZE_ICON_SIZE]: '16px',
        [ESizeTheme.SIZE_CHAT_TITLE]: '16px',
        [ESizeTheme.SIZE_PRIMARY_ICON]: '16px',
        [ESizeTheme.SIZE_LIST_ICON]: '30px',
        [ESizeTheme.SIZE_DEL_TAG_WIDTH]: '38px',
        [ESizeTheme.SIZE_TAG_HEIGHT]: '16px',
        [ESizeTheme.SIZE_EXT_TAG_WIDTH]: '28px',
        [ESizeTheme.SIZE_FRAME_SIZE]: '308px',
    },
};

const sizeMedium = {
    name: 'fontSizeMedium',
    description: '中字号调节',
    size: {
        [ESizeTheme.SIZE_PRIMARY_TITLE]: '15px',
        [ESizeTheme.SIZE_SUB_TITLE]: '13px',
        [ESizeTheme.SIZE_ICON_SIZE]: '16px',
        [ESizeTheme.SIZE_CHAT_TITLE]: '17px',
        [ESizeTheme.SIZE_PRIMARY_ICON]: '16px',
        [ESizeTheme.SIZE_LIST_ICON]: '32px',
        [ESizeTheme.SIZE_DEL_TAG_WIDTH]: '44px',
        [ESizeTheme.SIZE_TAG_HEIGHT]: '19px',
        [ESizeTheme.SIZE_EXT_TAG_WIDTH]: '32px',
        [ESizeTheme.SIZE_FRAME_SIZE]: '312px',
    },
};

const sizeLarge = {
    name: 'fontSizeLarge',
    description: '大字号调节',
    size: {
        [ESizeTheme.SIZE_PRIMARY_TITLE]: '17px',
        [ESizeTheme.SIZE_SUB_TITLE]: '15px',
        [ESizeTheme.SIZE_ICON_SIZE]: '18px',
        [ESizeTheme.SIZE_CHAT_TITLE]: '18px',
        [ESizeTheme.SIZE_PRIMARY_ICON]: '18px',
        [ESizeTheme.SIZE_LIST_ICON]: '36px',
        [ESizeTheme.SIZE_DEL_TAG_WIDTH]: '50px',
        [ESizeTheme.SIZE_TAG_HEIGHT]: '21px',
        [ESizeTheme.SIZE_EXT_TAG_WIDTH]: '36px',
        [ESizeTheme.SIZE_FRAME_SIZE]: '322px',
    },
};

const sizeXLarge = {
    name: 'fontSizeXLarge',
    description: '特大字号调节',
    size: {
        [ESizeTheme.SIZE_PRIMARY_TITLE]: '20px',
        [ESizeTheme.SIZE_SUB_TITLE]: '18px',
        [ESizeTheme.SIZE_ICON_SIZE]: '22px',
        [ESizeTheme.SIZE_CHAT_TITLE]: '20px',
        [ESizeTheme.SIZE_PRIMARY_ICON]: '22px',
        [ESizeTheme.SIZE_LIST_ICON]: '40px',
        [ESizeTheme.SIZE_DEL_TAG_WIDTH]: '50px',
        [ESizeTheme.SIZE_TAG_HEIGHT]: '21px',
        [ESizeTheme.SIZE_EXT_TAG_WIDTH]: '36px',
        [ESizeTheme.SIZE_FRAME_SIZE]: '336px',
    },
};

const SIZE_MODE_DATA = {
    [EFontSizeMode.STANDARD]: sizeStandard,
    [EFontSizeMode.MEDIUM]: sizeMedium,
    [EFontSizeMode.LARGE]: sizeLarge,
    [EFontSizeMode.X_LARGE]: sizeXLarge,
};

const SIZE_THEME_STYLE_ID = 'user-card-size-theme';

const POPPER_CON_CLASS = 'woa-popper user-card-popper-container';
const MASK_CLASS = 'woa-popper-mask user-card-mask';
const DEFAULT_OPTIONS = {
    cardType: EUserCardType.NORMAL,
    placement: 'right-start',
};
class UserCardPopper extends BasePopper {
    constructor() {
        super();
        this.userCardInstance = null;
        this.popper = null;
        this.options = DEFAULT_OPTIONS;
        this.visible = false;
        this.nodeZIndex = {
            mask: '',
            popper: '',
        };
        this.clickEventStop$ = null;
        this.mask = this.createMask();
        this.popperContainer = this.createPopperContainer();
        this.bindMaskEvent();
        this.bindKeyboardEvent();
        this.bindCloseBus();
    }
    /**
     * @description 创建容器
     */
    createPopperContainer() {
        const container = document.createElement('div');
        container.className = POPPER_CON_CLASS;
        container.style.cssText = `position: fixed;top: 0;left: 0;height: 0;`;
        return container;
    }
    /**
     * @description 创建罩层
     */
    createMask() {
        const mask = document.createElement('div');
        mask.className = MASK_CLASS;
        mask.style.cssText = `position: fixed;top: 0;left: 0;right: 0;bottom: 0;`;
        return mask;
    }
    /**
     * @description 创建UserCard组件实例
     */
    createComp() {
        return __awaiter(this, void 0, void 0, function* () {
            // 销毁之前的组件
            if (this.userCardInstance) {
                this.userCardInstance.$destroy();
            }
            const { default: UserCard } = yield Promise.resolve().then(function () { return index; });
            const UserCardCtor = Vue.extend(UserCard);
            this.userCardInstance = new UserCardCtor({
                propsData: {
                    options: this.options,
                    onOpenPopper: this.openPopper.bind(this),
                },
            });
            this.userCardInstance.$mount();
        });
    }
    /**
     * @description 绑定罩层点击事件
     */
    bindMaskEvent() {
        this.mask.addEventListener('click', (e) => {
            this.close();
            e.stopPropagation();
        });
    }
    /**
     * @description 绑定键盘事件
     */
    bindKeyboardEvent() {
        tinykeys(window, {
            [VALUE_ESCAPE]: () => {
                // esc 关闭子 popper，再关闭主 popper
                if (this.userCardInstance) {
                    if (this.userCardInstance.isSubPopperVisible) {
                        this.userCardInstance.closeSubPopper();
                        return;
                    }
                }
                if (this.visible) {
                    this.close();
                }
            },
        });
    }
    /**
     * @description 销毁popper和UserCard实例
     */
    destoryInstance() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
        if (this.userCardInstance) {
            this.userCardInstance.onOpenPopper = () => { };
            this.userCardInstance.$destroy();
            this.userCardInstance.$el.remove();
            this.userCardInstance = null;
        }
    }
    /**
     * @description 移除节点
     */
    removeNode() {
        this.mask.remove();
        this.popperContainer.remove();
    }
    /**
     * @description 创建popper
     */
    openPopper() {
        var _a;
        const { event, refrence, openOnMousePosition, popperModifiers } = this.options;
        let refrenceNode = null;
        // openOnMousePosition > event > refrence
        if (openOnMousePosition && event) {
            const { clientX: x, clientY: y } = event;
            refrenceNode = {
                getBoundingClientRect() {
                    return {
                        top: y,
                        right: x,
                        bottom: y,
                        left: x,
                        width: 0,
                        height: 0,
                    };
                },
            };
        }
        else if (event) {
            refrenceNode = event.target;
        }
        else {
            refrenceNode = refrence;
        }
        const popperNode = (_a = this.userCardInstance) === null || _a === void 0 ? void 0 : _a.$el;
        if (!refrenceNode || !popperNode)
            return;
        this.popperContainer.appendChild(popperNode);
        this.createPopper(refrenceNode, popperNode, popperModifiers);
    }
    /**
     * @description 创建popper实例
     */
    createPopper(refrenceNode, popperNode, popperModifiers) {
        const { placement } = this.options;
        const zIndex = this.nodeZIndex.popper;
        popperModifiers = popperModifiers || [];
        this.popper = createPopper(refrenceNode, popperNode, {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
                {
                    name: 'eventListeners',
                    options: {
                        scroll: false,
                    },
                },
                {
                    name: 'computeStyles',
                    options: {
                        gpuAcceleration: false,
                        roundOffsets: ({ x, y }) => {
                            return {
                                x: x,
                                y: Math.round(y - 16),
                            };
                        },
                    },
                },
                {
                    name: 'setStyles',
                    enabled: true,
                    phase: 'beforeWrite',
                    fn({ state }) {
                        state.styles.popper.zIndex = zIndex;
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                    },
                },
                ...popperModifiers,
            ],
            placement,
        });
    }
    /**
     * @description 同步element-ui层级计算
     */
    getZIndex() {
        return PopupManager.nextZIndex();
    }
    /**
     * @description 外部打开用户卡片方法
     * @param {IUserCardOptions}
     */
    open(options) {
        return __awaiter(this, void 0, void 0, function* () {
            // 避免重复渲染
            if (this.visible) {
                return this.close();
            }
            this.options = Object.assign({}, DEFAULT_OPTIONS, options);
            const { mask, popper } = this.options.nodeZIndex || {};
            this.nodeZIndex = {
                mask: mask || this.getZIndex(),
                popper: popper || this.getZIndex(),
            };
            const { mountTo } = this.options;
            const container = (isString(mountTo) ? mountTo && document.querySelector(mountTo) : mountTo) || document.body;
            this.mask.style.zIndex = this.nodeZIndex.mask;
            // 动态设置层级，保证名片不会被覆盖
            // todo: 团队广场这里有层级问题
            // this.popperContainer.style.zIndex = this.getZIndex() + 100
            this.popperContainer.style.zIndex = popper ? popper : this.getZIndex();
            this.popperContainer.appendChild(this.mask);
            container.appendChild(this.popperContainer);
            initSizeTheme(SIZE_MODE_DATA[this.options.sizeTheme || EFontSizeMode.STANDARD].size, SIZE_THEME_STYLE_ID);
            yield this.createComp();
            this.visible = true;
        });
    }
    refresh(options) {
        this.options = Object.assign({}, this.options, options);
        if (this.userCardInstance) {
            this.userCardInstance.options = this.options;
            this.userCardInstance.renderContent();
        }
    }
    // 字体大小改变
    onSizeChange(sizeMode) {
        sizeMode = sizeMode || this.options.sizeTheme || EFontSizeMode.STANDARD;
        this.options.sizeTheme = sizeMode;
        setSizeTheme(SIZE_MODE_DATA[sizeMode].size, SIZE_THEME_STYLE_ID);
    }
    /**
     * @description 外部关闭用户卡片方法
     */
    close() {
        if (this.visible) {
            this.destoryInstance();
            this.removeNode();
            this.options.onClose && this.options.onClose();
            this.visible = false;
        }
    }
    bindCloseBus() {
        PopperManager$1.register(EPopperType.USER_CARD, () => this.close());
    }
    setClickEventStop$(sub) {
        this.clickEventStop$ = sub;
    }
    triggerClickEventStop$() {
        if (this.clickEventStop$) {
            this.clickEventStop$.next();
            this.clickEventStop$.complete();
        }
    }
}
var userCardPopper = new UserCardPopper();

Vue.use(Input);
Vue.use(Popover);
Vue.use(Link);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Scrollbar);

Vue.use(Tooltip);
Vue.use(Loading);

!function (o) {
  if (typeof window === 'undefined') return;
  var l,
    a = '<svg aria-hidden="true" style="position:absolute;width:0;height:0;overflow:hidden" xmlns="http://www.w3.org/2000/svg"><defs><symbol id="am-icon-chat" viewBox="0 0 32 32"><path fill="#fff" style="fill:var(--color1, #fff)" d="M30 0a2 2 0 0 1 2 2v22a2 2 0 0 1-2 2H12l-6.4 4.8A1 1 0 0 1 4 30v-4H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h28zM7.5 10.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm8.5 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm8.5 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></symbol><symbol id="am-icon-close" viewBox="0 0 32 32"><path fill="#949aae" style="fill:var(--color2, #949aae)" d="m25.899 24.485-1.414 1.414L6.1 7.514 7.514 6.1l18.385 18.385z"/><path fill="#949aae" style="fill:var(--color2, #949aae)" d="m24.485 6.101 1.414 1.414L7.514 25.9 6.1 24.486 24.485 6.101z"/></symbol><symbol id="am-icon-copy" viewBox="0 0 32 32"><path d="M22 20a2 2 0 0 1-2 2h-8v4h14V12h-4v8zM20 6H6v14h14V6zm-8 22a2 2 0 0 1-2-2v-4H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H12z"/></symbol><symbol id="am-icon-deleted-tag" viewBox="0 0 32 32"><path fill="#e1e6eb" style="fill:var(--color3, #e1e6eb)" d="M2.526 9.263h26.947a2.526 2.526 0 0 1 2.526 2.526v8.421a2.526 2.526 0 0 1-2.526 2.526H2.526A2.526 2.526 0 0 1 0 20.21v-8.421a2.526 2.526 0 0 1 2.526-2.526z"/><path fill="#0c0f17" style="fill:var(--color4, #0c0f17)" opacity=".58" d="M10.4 16.303v-3.368H4.168v.589h5.617v2.198H5.111v-1.246h-.606v4.421c0 .691.337 1.044 1.019 1.044h4.564c.354-.017.632-.109.817-.286.202-.219.345-.842.429-1.886l-.589-.185c-.051.926-.16 1.465-.328 1.617a.777.777 0 0 1-.497.152H5.693c-.387 0-.581-.194-.581-.564v-2.484H10.4zm7.217-3.04v5.229h.531v-5.229h-.531zm1.179 6.88c.472 0 .716-.269.716-.792v-6.829h-.556v6.695c0 .278-.118.421-.354.421-.312 0-.64-.017-.977-.034l.126.539h1.044zm-6.594-4.278v.547h.514c-.017 1.364-.211 2.484-.581 3.377l.429.387c.421-.96.648-2.215.674-3.764h.733v2.981c0 .194-.093.295-.278.295a4.58 4.58 0 0 1-.463-.025l.135.505h.497c.421 0 .632-.202.632-.598v-3.158h.598v.16c-.008 1.297-.143 2.375-.404 3.225l.421.379c.32-.926.488-2.147.497-3.646v-.118h.724v2.998c0 .185-.076.286-.219.286s-.295-.008-.446-.025l.135.505h.472c.387 0 .589-.202.589-.589v-3.175h.463v-.547h-.463v-3.048h-1.768v3.048h-.598v-3.048h-1.777v3.048h-.514zm4.126 0h-.724v-2.526h.724v2.526zm-2.357 0h-.733v-2.526h.733v2.526zm6.93-3.04v7.394h.589v-6.821h1.187a26.427 26.427 0 0 1-.792 2.392c.505.699.758 1.331.758 1.895 0 .185-.051.312-.135.387s-.261.118-.522.135c-.084 0-.194-.017-.328-.034l.202.615c.547 0 .935-.109 1.154-.312.152-.16.236-.421.236-.792-.034-.589-.286-1.255-.758-1.987.312-.825.581-1.625.8-2.392v-.48H20.9zm4.547 7.301c.421 0 .64-.236.64-.699v-2.509h1.886v-.589h-1.886v-.994h1.027v-.564h-2.762v.564h1.112v.994h-1.971v.589h1.971v2.358c0 .194-.076.295-.227.295-.253 0-.522-.017-.8-.034l.135.589h.876zm.026-7.511a7.249 7.249 0 0 1-2.299 2.223l.345.514c.876-.539 1.625-1.263 2.248-2.156a6.29 6.29 0 0 0 2.206 2.105l.354-.514c-1.002-.581-1.76-1.305-2.265-2.173h-.589zm1.583 4.876-.472.286c.421.691.758 1.314 1.002 1.878l.505-.345a15.641 15.641 0 0 0-1.036-1.819zm-2.788.042a7.45 7.45 0 0 1-1.145 1.819l.497.354c.446-.539.834-1.179 1.171-1.912l-.522-.261z"/></symbol><symbol id="am-icon-desktop-online" viewBox="0 0 32 32"><path d="M27.333 4A2.667 2.667 0 0 1 30 6.667v14.634a2.667 2.667 0 0 1-2.667 2.667H20v1l3.872 2.258a.26.26 0 0 1 .128.224.518.518 0 0 1-.518.518H8.518A.518.518 0 0 1 8 27.45c0-.092.049-.177.128-.224L12 24.968v-1H4.667A2.667 2.667 0 0 1 2 21.301V6.667A2.667 2.667 0 0 1 4.667 4h22.667zm0 2H4.666a.666.666 0 0 0-.662.589L4 6.667v14.634c0 .342.257.624.589.662l.078.004h22.667a.666.666 0 0 0 .662-.589L28 21.3V6.666a.666.666 0 0 0-.589-.662L27.333 6z"/></symbol><symbol id="am-icon-edit" viewBox="0 0 32 32"><path fill="#767c85" style="fill:var(--color5, #767c85)" d="M28 28v2H4v-2h24zM23.226 2.248l.188.166 4.172 4.172a2 2 0 0 1 .166 2.64l-.166.188L11 26H4v-7L20.586 2.414a2 2 0 0 1 2.64-.166zm-6.02 6.372L6 19.828V24h4.168l11.208-11.21-4.17-4.17zM22 3.828l-3.38 3.378 4.17 4.17L26.172 8 22 3.828z"/></symbol><symbol id="am-icon-external-tag-white" viewBox="0 0 32 32"><path fill="#f0f7ff" style="fill:var(--color6, #f0f7ff)" d="M3.429 6.857h25.143a3.429 3.429 0 0 1 3.429 3.429v11.429a3.429 3.429 0 0 1-3.429 3.429H3.429A3.429 3.429 0 0 1 0 21.715V10.286a3.429 3.429 0 0 1 3.429-3.429z"/><path fill="#0a6cff" style="fill:var(--color7, #0a6cff)" d="M11.84 11.257v10.446h.846v-6.08c.663.526 1.451 1.269 2.389 2.206l.503-.754a38.934 38.934 0 0 0-2.891-2.366v-3.451h-.846zm-4.617 4.537-.434.64c.606.297 1.211.709 1.806 1.211-.8 1.234-1.92 2.263-3.349 3.086l.56.697c2.971-1.771 4.64-4.389 5.029-7.851v-.72H8.058c.16-.469.297-.96.411-1.474l-.823-.137c-.457 2.057-1.349 3.703-2.651 4.914l.56.697c.914-.846 1.657-1.909 2.206-3.211h2.263a10.268 10.268 0 0 1-1.051 3.349 9.49 9.49 0 0 0-1.749-1.2zm10.926-2.228-.754.274c.286.503.526 1.051.731 1.646h-1.543v.8h5.726v-.8h-1.383c.297-.514.56-1.097.8-1.749l-.766-.263a12.58 12.58 0 0 1-.846 2.011h-1.2a11.165 11.165 0 0 0-.766-1.92zm4.685-1.852v9.977h.8v-9.223h2.046a32.07 32.07 0 0 1-1.12 3.211c.891 1.097 1.349 1.977 1.36 2.651-.011.411-.069.686-.183.834-.114.137-.377.217-.789.24-.217 0-.48-.023-.8-.046l.263.869c.937 0 1.566-.149 1.886-.423.297-.274.446-.766.446-1.474-.011-.686-.446-1.577-1.303-2.651a38.217 38.217 0 0 0 1.143-3.349v-.617h-3.749zm-6.034.629v.8h5.429v-.8h-2.331a18.297 18.297 0 0 0-.377-1.177l-.846.149c.149.309.286.651.423 1.029h-2.297zm4.983 4.983h-4.549v4.309h.811v-.64h2.926v.64h.811v-4.309zm-3.737 2.891v-2.114h2.926v2.114h-2.926z"/></symbol><symbol id="am-icon-external-tag" viewBox="0 0 32 32"><path fill="#0a6cff" style="fill:var(--color7, #0a6cff)" opacity=".08" d="M3.429 6.857h25.143a3.429 3.429 0 0 1 3.429 3.429v11.429a3.429 3.429 0 0 1-3.429 3.429H3.429A3.429 3.429 0 0 1 0 21.715V10.286a3.429 3.429 0 0 1 3.429-3.429z"/><path fill="#0a6cff" style="fill:var(--color7, #0a6cff)" d="M11.84 11.257v10.446h.846v-6.08c.663.526 1.451 1.269 2.389 2.206l.503-.754a38.934 38.934 0 0 0-2.891-2.366v-3.451h-.846zm-4.617 4.537-.434.64c.606.297 1.211.709 1.806 1.211-.8 1.234-1.92 2.263-3.349 3.086l.56.697c2.971-1.771 4.64-4.389 5.029-7.851v-.72H8.058c.16-.469.297-.96.411-1.474l-.823-.137c-.457 2.057-1.349 3.703-2.651 4.914l.56.697c.914-.846 1.657-1.909 2.206-3.211h2.263a10.268 10.268 0 0 1-1.051 3.349 9.49 9.49 0 0 0-1.749-1.2zm10.926-2.228-.754.274c.286.503.526 1.051.731 1.646h-1.543v.8h5.726v-.8h-1.383c.297-.514.56-1.097.8-1.749l-.766-.263a12.58 12.58 0 0 1-.846 2.011h-1.2a11.165 11.165 0 0 0-.766-1.92zm4.685-1.852v9.977h.8v-9.223h2.046a32.07 32.07 0 0 1-1.12 3.211c.891 1.097 1.349 1.977 1.36 2.651-.011.411-.069.686-.183.834-.114.137-.377.217-.789.24-.217 0-.48-.023-.8-.046l.263.869c.937 0 1.566-.149 1.886-.423.297-.274.446-.766.446-1.474-.011-.686-.446-1.577-1.303-2.651a38.217 38.217 0 0 0 1.143-3.349v-.617h-3.749zm-6.034.629v.8h5.429v-.8h-2.331a18.297 18.297 0 0 0-.377-1.177l-.846.149c.149.309.286.651.423 1.029h-2.297zm4.983 4.983h-4.549v4.309h.811v-.64h2.926v.64h.811v-4.309zm-3.737 2.891v-2.114h2.926v2.114h-2.926z"/></symbol><symbol id="am-icon-leave" viewBox="0 0 32 32"><path fill="none" stroke="#cad1db" style="stroke:var(--color8, #cad1db)" stroke-width="2" d="M29 16c0 7.18-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3s13 5.82 13 13z"/><path fill="#cad1db" style="fill:var(--color8, #cad1db)" d="M16 7a1 1 0 0 1 1 1v7h6a1 1 0 0 1 0 2h-7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"/></symbol><symbol id="am-icon-m-chat" viewBox="0 0 32 32"><path fill="#fff" style="fill:var(--color1, #fff)" d="M26.667 4.267c1.178 0 2.133.955 2.133 2.133v16.533a2.133 2.133 0 0 1-2.133 2.133H14.97a.532.532 0 0 0-.308.098l-4.98 3.515A1.067 1.067 0 0 1 8 27.808V25.6a.533.533 0 0 0-.533-.533h-1.6a2.133 2.133 0 0 1-2.133-2.133V6.401c0-1.178.955-2.133 2.133-2.133h20.8zM10.4 12.8a1.867 1.867 0 1 0 0 3.734 1.867 1.867 0 0 0 0-3.734zm5.867 0a1.867 1.867 0 1 0 0 3.734 1.867 1.867 0 0 0 0-3.734zm5.866 0a1.867 1.867 0 1 0 0 3.734 1.867 1.867 0 0 0 0-3.734z"/></symbol><symbol id="am-icon-m-female" viewBox="0 0 32 32"><path fill="#ff8c8c" style="fill:var(--color9, #ff8c8c)" d="M16 3.333a7.59 7.59 0 0 1 7.511 6.504l1.141 7.901a.666.666 0 0 1-.66.762h-4.706v.375c0 .431.253.822.646.999l9.828 4.419a2.666 2.666 0 0 1 1.573 2.432v1.942a.667.667 0 0 1-.667.667H1.333a.667.667 0 0 1-.667-.667v-1.942c0-1.05.616-2.002 1.573-2.432l9.828-4.419c.393-.177.646-.568.646-.999V18.5H8.007a.667.667 0 0 1-.66-.762l1.141-7.901a7.59 7.59 0 0 1 7.511-6.504zm-4.341 17.334c-.22 3.38.471 5.266 2.074 5.656 2.404.586 2.404-1.092 2.169-2.059-.473-.614-1.887-1.813-4.243-3.597zm8.682 0c-2.356 1.784-3.77 2.983-4.243 3.597-.235.968-.235 2.646 2.169 2.059 1.602-.391 2.294-2.276 2.074-5.656z"/></symbol><symbol id="am-icon-m-male" viewBox="0 0 32 32"><path fill="#4fa7ff" style="fill:var(--color10, #4fa7ff)" d="M16 2.667a6.564 6.564 0 0 1 6.457 5.388l.114.626a11.65 11.65 0 0 1-3.231 10.332l-.055.055v.388c0 .43.251.82.643.997l9.84 4.465a2.666 2.666 0 0 1 1.565 2.428v1.988a.667.667 0 0 1-.667.667H1.333a.667.667 0 0 1-.667-.667v-1.988c0-1.046.612-1.996 1.565-2.428l9.84-4.465c.391-.178.643-.568.643-.997v-.388l-.055-.055A11.651 11.651 0 0 1 9.428 8.681l.114-.626a6.564 6.564 0 0 1 6.457-5.388zm.643 18.468h-1.286a.668.668 0 0 0-.62.42l-1.436 3.612a.667.667 0 0 0 .14.71l2.079 2.15.016.016a.667.667 0 0 0 .943-.016l2.079-2.15a.667.667 0 0 0 .14-.71l-1.436-3.612a.666.666 0 0 0-.62-.42z"/></symbol><symbol id="am-icon-m-meeting" viewBox="0 0 32 32"><path d="M17.147 20.813c1.131.956 2.051 1.044 2.986.272 1.797-1.8 3.387-1.326 5.949.506s1.874 2.554.839 3.949c-.633.853-1.605 1.453-2.917 1.801l-.366.089c-3.802 1.056-8.186-.848-12.924-5.596S4.171 12.993 5.041 9.231l.089-.35c.329-1.501.958-2.598 1.886-3.29 1.392-1.038 2.112-1.726 3.94.841l.371.536c1.514 2.26 1.803 3.754.134 5.425-.771.938-.672 1.88.281 3.014l5.406 5.406z"/></symbol><symbol id="am-icon-m-privacy" viewBox="0 0 32 32"><path fill="#aaacb0" style="fill:var(--color11, #aaacb0)" d="M6 30a2.667 2.667 0 0 1-2.667-2.667V14.777A2.667 2.667 0 0 1 6 12.11h2V9.999a8 8 0 0 1 16 0v2.111h2a2.667 2.667 0 0 1 2.667 2.667v12.556A2.667 2.667 0 0 1 26 30H6zm10-13.333a2.667 2.667 0 0 0-1.334 4.977v3.023c0 .342.257.624.589.662l.078.005h1.333a.666.666 0 0 0 .662-.589l.005-.078.001-3.024A2.667 2.667 0 0 0 16 16.667zm0-11.334a4.667 4.667 0 0 0-4.664 4.506l-.003.16v2.111h9.333V9.999a4.667 4.667 0 0 0-4.667-4.667z"/></symbol><symbol id="am-icon-mobile-online" viewBox="0 0 32 32"><path d="M23.333 2A2.667 2.667 0 0 1 26 4.667v22.667a2.667 2.667 0 0 1-2.667 2.667H8.666a2.667 2.667 0 0 1-2.667-2.667V4.667A2.667 2.667 0 0 1 8.666 2h14.667zM11.667 4H9a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H11.667zM13 24a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6z"/></symbol><symbol id="am-icon-more-arrow" viewBox="0 0 32 32"><path fill="#d0d2d5" style="fill:var(--color12, #d0d2d5)" d="m12.97 5.263 9.891 9.537c.65.627.678 1.65.085 2.312l-.085.088-9.891 9.537a.667.667 0 0 1-.943-.017l-1.388-1.44a.667.667 0 0 1 .017-.943l8.647-8.338-8.647-8.338a.667.667 0 0 1-.017-.943l1.388-1.44a.667.667 0 0 1 .943-.017z"/></symbol><symbol id="am-icon-offline" viewBox="0 0 32 32"><path d="M16 28C9.373 28 4 22.627 4 16S9.373 4 16 4s12 5.373 12 12-5.373 12-12 12zm0 2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z"/><path d="M8.5 16a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H10A1.5 1.5 0 0 1 8.5 16z"/></symbol><symbol id="am-icon-phone-number-hide" viewBox="0 0 32 32"><path d="m29.814 9.677 1.766.938c-1.124 2.117-2.84 3.928-4.954 5.32l4.576 5.451-1.532 1.286-4.802-5.722a19.213 19.213 0 0 1-5.174 1.718l3.037 5.261-1.732 1-3.457-5.985a20.733 20.733 0 0 1-4.283-.125l-3.528 6.11-1.732-1 3.175-5.501a18.945 18.945 0 0 1-4.234-1.575l-4.88 5.818-1.532-1.286 4.671-5.566C3.333 14.557 1.787 12.963.7 11.117l-.263-.468 1.764-.943C4.539 14.076 9.922 17 16 17c5.889 0 11.125-2.745 13.571-6.889l.243-.434z"/></symbol><symbol id="am-icon-phone-number-show" viewBox="0 0 32 32"><path d="M16 4c5.891 0 11.224 4 16 12-4.776 8-10.109 12-16 12S4.776 24 0 16C4.776 8 10.109 4 16 4zm0 2c-4.791 0-9.269 3.184-13.461 9.796L2.412 16l.127.204c4.048 6.384 8.361 9.572 12.966 9.784l.495.011c4.791 0 9.269-3.184 13.461-9.796l.125-.206-.125-.202C25.413 9.411 21.1 6.223 16.495 6.011L16 6z"/><path d="M16 10a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/></symbol><symbol id="am-icon-user-gender-female" viewBox="0 0 32 32"><path fill="#f99" style="fill:var(--color13, #f99)" d="M17.048 4a6.125 6.125 0 0 1 5.989 4.842l1.736 8.1A.875.875 0 0 1 23.918 18H20v.459c0 .331.187.634.484.783l8.549 4.274c.593.296.967.902.967 1.565v2.043a.875.875 0 0 1-.875.875H2.875A.875.875 0 0 1 2 27.124v-2.043c0-.663.374-1.269.967-1.565l8.549-4.274a.876.876 0 0 0 .484-.783V18H8.082a.875.875 0 0 1-.856-1.058l1.736-8.1A6.125 6.125 0 0 1 14.951 4h2.097zm-5.012 16c-.201 3.12.43 4.861 1.893 5.221 2.195.541 2.195-1.008 1.98-1.901-.432-.567-1.723-1.673-3.874-3.321zm7.928 0c-2.151 1.647-3.442 2.754-3.874 3.321-.214.893-.214 2.442 1.98 1.901 1.463-.361 2.094-2.101 1.893-5.221z"/></symbol><symbol id="am-icon-user-gender-male" viewBox="0 0 32 32"><path fill="#70d4ff" style="fill:var(--color14, #70d4ff)" d="M16 3a5.991 5.991 0 0 1 5.894 4.919l.285 1.57a10.498 10.498 0 0 1-1.931 8.178l-.249.332v.459c0 .331.187.634.484.783l8.549 4.274c.593.296.967.902.967 1.565v2.043a.875.875 0 0 1-.875.875H2.874a.875.875 0 0 1-.875-.875V25.08c0-.663.374-1.269.967-1.565l8.549-4.274a.876.876 0 0 0 .484-.783v-.459l-.249-.332a10.498 10.498 0 0 1-1.931-8.178l.285-1.57A5.99 5.99 0 0 1 15.998 3zm-.049 17a.868.868 0 0 0-.831.595l-.987 3.001a.876.876 0 0 0 .103.759l1.036 1.554a.875.875 0 0 0 1.456 0l1.028-1.542a.874.874 0 0 0 .096-.78l-1.077-3.006a.875.875 0 0 0-.824-.58z"/></symbol><symbol id="am-icon-user-gender-privacy" viewBox="0 0 32 32"><path fill="#fff" style="fill:var(--color1, #fff)" opacity=".328" d="M16 2a8 8 0 0 1 8 8v1.998l1.375.002A2.625 2.625 0 0 1 28 14.625v12.75A2.625 2.625 0 0 1 25.375 30H6.625A2.625 2.625 0 0 1 4 27.375v-12.75A2.625 2.625 0 0 1 6.625 12L8 11.998V10a8 8 0 0 1 8-8zm0 14a3 3 0 0 0-1.701 5.471L14.3 24.3a1.7 1.7 0 1 0 3.4 0l.003-2.83A3 3 0 0 0 16 16zm0-10.6a4.599 4.599 0 0 0-4.589 4.285L11.4 10l-.002 1.998H20.6V10A4.6 4.6 0 0 0 16 5.4z"/></symbol><symbol id="am-icon-user-gender-privacy1" viewBox="0 0 32 32"><path fill="#c1c5cb" style="fill:var(--color15, #c1c5cb)" d="M16 2a8 8 0 0 1 8 8v1.998l1.375.002A2.625 2.625 0 0 1 28 14.625v12.75A2.625 2.625 0 0 1 25.375 30H6.625A2.625 2.625 0 0 1 4 27.375v-12.75A2.625 2.625 0 0 1 6.625 12L8 11.998V10a8 8 0 0 1 8-8zm0 14a3 3 0 0 0-1.701 5.471L14.3 24.3a1.7 1.7 0 1 0 3.4 0l.003-2.83A3 3 0 0 0 16 16zm0-10.6a4.599 4.599 0 0 0-4.589 4.285L11.4 10l-.002 1.998H20.6V10A4.6 4.6 0 0 0 16 5.4z"/></symbol><symbol id="am-icon-video" viewBox="0 0 32 32"><path fill="#417ff9" style="fill:var(--color16, #417ff9)" d="M22.25 4c.966 0 1.75.784 1.75 1.75v3.609l3.084-2.755A1.75 1.75 0 0 1 30 7.909v14.399a1.75 1.75 0 0 1-3.072 1.146L24 20.076v4.173a1.75 1.75 0 0 1-1.75 1.75H1.75A1.75 1.75 0 0 1 0 24.249v-18.5c0-.966.783-1.75 1.75-1.75h20.5zM10 10.6v8.8l8-4.4-8-4.4z"/></symbol></defs></svg>',
    h = (l = document.getElementsByTagName('script'))[l.length - 1].getAttribute('data-injectcss');
  if (h && !o.__iconfont__svg__cssinject__) {
    o.__iconfont__svg__cssinject__ = !0;
  }
  !function (l) {
    if (document.addEventListener) {
      if (~['complete', 'loaded', 'interactive'].indexOf(document.readyState)) setTimeout(l, 0);else {
        var h = function () {
          document.removeEventListener('DOMContentLoaded', h, !1), l();
        };
        document.addEventListener('DOMContentLoaded', h, !1);
      }
    } else document.attachEvent && (c = l, i = o.document, t = !1, (v = function () {
      try {
        i.documentElement.doScroll('left');
      } catch (l) {
        return void setTimeout(v, 50);
      }
      a();
    })(), i.onreadystatechange = function () {
      'complete' == i.readyState && (i.onreadystatechange = null, a());
    });
    function a() {
      t || (t = !0, c());
    }
    var c, i, t, v;
  }(function () {
    var l, h;
    (l = document.createElement('div')).innerHTML = a, a = null, (h = l.getElementsByTagName('svg')[0]) && (h.setAttribute('aria-hidden', 'true'), h.style.position = 'absolute', h.style.width = 0, h.style.height = 0, h.style.overflow = 'hidden', function (l, h) {
      h.firstChild ? function (l, h) {
        h.parentNode.insertBefore(l, h);
      }(l, h.firstChild) : h.appendChild(l);
    }(h, document.body));
  });
}(window);

const ctxContainer = new Map();
const WoaVueContext = {
    extends: VueContext,
    props: {
        diabledScroller: {
            validator(v) {
                return (v.$el && v.$el instanceof HTMLElement) || v instanceof HTMLElement;
            },
        },
    },
    watch: {
        show(val) {
            const ctx = this;
            const scroller = ctx.$props.diabledScroller;
            // 存在需要禁用的滚动条
            if (scroller) {
                const classname = 'disable-scroll';
                const el = scroller.$el || scroller;
                const action = val ? 'add' : 'remove';
                el.classList[action](classname);
            }
            if (val) {
                // 关闭所有其他打开的右键菜单
                ctxContainer.forEach((item) => {
                    if (item.close)
                        item.close();
                });
                ctxContainer.set(ctx._uid, ctx);
            }
            else {
                ctxContainer.delete(ctx._uid);
            }
        },
    },
};

async function getDocumentHeaders() {
  var req = new XMLHttpRequest();
  var url = document.location.href;
  var prod = new Promise(function (resolve) {
    if (document.location.search) {
      url = url + '&debugger=1';
    } else {
      url = url + '?debugger=1';
    }
    req.open('GET', url, false);
    req.onload = function () {
      resolve(true);
    };
    req.send(null);
  });
  await prod;
  return req.getAllResponseHeaders().trim().split(/\n/).reduce((pre, acc) => {
    const offset = acc.indexOf(':');
    const key = acc.substr(0, offset).trim();
    pre[key] = acc.substr(offset + 1).trim();
    return pre;
  }, {});
}

const ENV_STORAGE_KEY = 'woa_release_env';
let env;
async function init(force) {
  if (typeof window !== 'undefined') {
    if (window.localStorage) {
      try {
        env = JSON.parse(window.localStorage.getItem(ENV_STORAGE_KEY));
      } catch (e) {
        //
      }
    }
  }
  if (env && !force) {
    // 以下判断主要解决金山协作端内公私网换包缓存获取错误
    // 网页端环境可以直接返回
    if (window.location.host) return env;
    // 客户端环境，判断当前若是公网，则需防止取到私网缓存
    if (!window.location.host && !getter._xOrigin_ && !env.xOrigin) return env;
    // 客户端环境，判断当前若是私网，则需防止取到公网缓存
    if (!window.location.host && env.xOrigin == getter._xOrigin_) return env;
  }
  let domain = typeof window !== 'undefined' && document.domain || '';
  const headers = typeof window !== 'undefined' && (await getDocumentHeaders()) || {};

  // 这一段逻辑是判断私有化/国际版，国内环境不要设置_xOrigin_，因为国内没entry服务
  if (getter._xOrigin_) {
    if (/^(https?:\/\/).+$/.test(getter._xOrigin_)) {
      const {
        hostname
      } = new Url(getter._xOrigin_);
      // 海外
      if (/^.+(\.wps\.com)$/.test(hostname)) {
        domain = hostname;
      }
      // 国内
      else {
        headers['x-origin'] = getter._xOrigin_;
      }
    } else {
      console.warn('xOrigin参数不正确，启动将自动切换为国内。');
    }
  }
  if (headers['x-origin']) {
    env = await window.fetch(`${headers['x-origin']}/drive/wps-private-entry.json`, {
      method: 'GET'
    }).then(res => res.json());
    env.xOrigin = headers['x-origin'];
  } else if (/^.+(\.wps\.com)$/.test(domain) || domain === 'wps.com') {
    const {
      hostname
    } = new Url(location.href);
    const matches = hostname.match(/^([^.-]+).+(wps\.com)$/);
    if (matches && matches[1]) {
      matches[1];
    }
  } else {
    env = {
      props: {
        release: 'default'
      }
    };
  }
  if (typeof window !== 'undefined') {
    if (window.localStorage) {
      window.localStorage.setItem(ENV_STORAGE_KEY, JSON.stringify(env));
    }
  }
  return env;
}
async function getter(key) {
  let opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  await init(opt.force);
  if (!key) {
    return env;
  } else {
    return get(env, key);
  }
}
getter._xOrigin_ = '';

const SVR = {
    PLUSSVR: 'plussvr',
    DRIVE: 'drive',
    RILI: 'rili',
    TODO_API: 'todo-api',
    WOA: 'woa',
    WOA_SUB: 'woa-sub',
    ACCOUNT: 'account',
    PLUS: 'plus',
    KDOCS: 'kdocs',
    FORM: 'form',
    WOA_DOCS: 'woa-docs',
    WOA_DOCS_TPL_LIB: 'woa-docs-tpllib',
    WEB_OFFICE: 'weboffice',
    DRIVE_KDOCS: 'drive-kdocs',
    SEC_DOC: 'security-doc',
    WOA_OPEN: 'woa-open',
    WOA_APP: 'woa-app',
};
const currentHost = typeof window !== undefined && window.location.hostname;
const PUBLIC_SERVICE_DICT = {
    [SVR.PLUSSVR]: 'plussvr.wps.cn',
    [SVR.DRIVE]: 'drive.wps.cn',
    [SVR.TODO_API]: 'todos-api.wps.cn',
    [SVR.WOA]: currentHost && currentHost.includes('kdocs') ? 'woa.kdocs.cn' : 'woa.wps.cn',
    [SVR.ACCOUNT]: 'account.wps.cn',
    [SVR.PLUS]: 'plus.wps.cn',
    [SVR.KDOCS]: 'www.kdocs.cn',
    [SVR.FORM]: 'f.wps.cn',
    [SVR.WOA_DOCS]: 'd-woa.wps.cn',
    [SVR.WOA_DOCS_TPL_LIB]: 'tpllib-woa.wps.cn',
    [SVR.DRIVE_KDOCS]: 'drive.kdocs.cn',
    [SVR.SEC_DOC]: 'securitydoc.wps.cn',
    // 公网没有此值，使用的是不同的域名
    [SVR.WOA_APP]: '',
    [SVR.WOA_SUB]: {
        address: {
            path: '/sub',
            host: 'woa.wps.cn',
            scheme: 'wss',
        },
    },
    [SVR.WOA_OPEN]: 'open-xz.wps.cn',
};
const PUBLIC_ENTRY_NAME = 'wps_public_net';
const PUBLIC_ENTRY = {
    zoneGroups: [],
    applications: [generateApplication(PUBLIC_ENTRY_NAME, { services: Object.keys(PUBLIC_SERVICE_DICT) })],
    version: '1',
    description: '公网网关配置',
    services: generateServices(PUBLIC_SERVICE_DICT),
};

const g = new KsGateway(PUBLIC_ENTRY);
function updateConfig(env) {
    return __awaiter(this, void 0, void 0, function* () {
        if (env) {
            g.setConfig(env);
        }
    });
}

const imgPublic = {
    publicDir: 'https://qn.cache.wpscdn.cn/koa/open-admin/static',
};
const updateImgPublic = (url) => {
    if (url) {
        let path = url.endsWith('/') ? url : url + '/';
        path += 'woa-open/admin/static';
        imgPublic.publicDir = path;
    }
};
const getImgPublic = () => {
    return imgPublic.publicDir;
};

// 表情图标
// 表情类型
var EmotionType;
(function (EmotionType) {
    EmotionType[EmotionType["EMOJI"] = 1] = "EMOJI";
    EmotionType[EmotionType["STICKER"] = 2] = "STICKER";
    EmotionType[EmotionType["CUSTOM"] = 3] = "CUSTOM";
    EmotionType[EmotionType["OFFICIAL_STICKER"] = 4] = "OFFICIAL_STICKER";
    EmotionType[EmotionType["OFFICIAL_JXM"] = 5] = "OFFICIAL_JXM";
})(EmotionType || (EmotionType = {}));

const emoji$1 = [
    {
        id: 10003,
        name: 'emoji',
        type: EmotionType.EMOJI,
        version: 7,
        coverVersion: '7_static',
        logo: 'CoverPicture.png',
        ext: 'png',
        icons: [
            { id: 1000100, key: 'Smile', alt: '微笑' },
            { id: 1000200, key: 'Pout', alt: '撇嘴' },
            { id: 1000300, key: 'Like', alt: '喜欢' },
            { id: 1000400, key: 'IntoSpace', alt: '发呆' },
            { id: 1000500, key: 'Elated', alt: '得意' },
            { id: 1000600, key: 'Bawling', alt: '大哭' },
            { id: 1000700, key: 'Shy', alt: '害羞' },
            { id: 1000800, key: 'Cried', alt: '哭了' },
            { id: 1000900, key: 'PissedOff', alt: '怒了' },
            { id: 1001000, key: 'Mischievous', alt: '调皮' },
            { id: 1001100, key: 'BaredTeeth', alt: '呲牙' },
            { id: 1001200, key: 'Pig', alt: '猪头' },
            { id: 1001300, key: 'Crazy', alt: '抓狂' },
            { id: 1001400, key: 'Puking', alt: '吐' },
            { id: 1001500, key: 'Snicker', alt: '偷笑' },
            { id: 1001600, key: 'RollYourEyes', alt: '白眼' },
            { id: 1001700, key: 'Insolence', alt: '傲娇' },
            { id: 1001800, key: 'Greedy', alt: '嘴馋' },
            { id: 1001900, key: 'Sweating', alt: '流汗' },
            { id: 1002000, key: 'Chuckle', alt: '憨笑' },
            { id: 1002100, key: 'BadLaugh', alt: '坏笑' },
            { id: 1002200, key: 'Decline', alt: '衰' },
            { id: 1002300, key: 'Panic', alt: '惊恐' },
            { id: 1002400, key: 'Goodbye', alt: '再见' },
            { id: 1002500, key: 'Embarrassing', alt: '糗' },
            { id: 1002600, key: 'NameCalling', alt: '骂人' },
            { id: 1002700, key: 'Kiss', alt: '亲亲' },
            { id: 1002800, key: 'Shh', alt: '嘘' },
            { id: 1002900, key: 'PickNose', alt: '抠鼻' },
            { id: 1003000, key: 'Applause', alt: '鼓掌' },
            { id: 1003100, key: 'HMM', alt: '哼' },
            { id: 1003200, key: 'Despises', alt: '鄙视' },
            { id: 1003300, key: 'ReadyToCry', alt: '要哭' },
            { id: 1003400, key: 'Sinister', alt: '阴险' },
            { id: 1003500, key: 'Poor', alt: '可怜' },
            { id: 1003600, key: 'Maohan', alt: '冒汗' },
            { id: 1003700, key: 'CockeyedSmile', alt: '斜眼笑' },
            { id: 1003800, key: 'Hip-hop', alt: '嘻哈' },
            { id: 1003900, key: 'CoverFaceAndSmile', alt: '捂脸', oldAlt: '捂脸笑' },
            { id: 1004000, key: 'LaughAndCry', alt: '笑哭' },
            { id: 1004100, key: 'Smart', alt: '机智' },
            { id: 1004200, key: 'InTheFace', alt: '打脸' },
            { id: 1004300, key: 'StickTongue', alt: '二哈' },
            { id: 1004400, key: 'DogHead', alt: '狗头' },
            { id: 1004500, key: 'Shock', alt: '震惊' },
            { id: 1004600, key: 'emm', alt: 'emm' },
            { id: 1004700, key: 'Refuel', alt: '加油' },
            { id: 1004800, key: 'Stunned', alt: 'O了' },
            { id: 1004825, key: 'Got', alt: '收到' },
            { id: 1004850, key: 'Done', alt: 'done' },
            { id: 1004875, key: 'Get', alt: 'get' },
            { id: 1004900, key: 'Inexplicable', alt: '费解' },
            { id: 1005000, key: 'Thinking', alt: '思考' },
            { id: 1005100, key: 'ShutUp', alt: '闭嘴' },
            { id: 1005200, key: 'Dizzy', alt: '晕' },
            { id: 1005300, key: 'Cute', alt: '卖萌' },
            { id: 1005400, key: 'EatMelon', alt: '吃瓜' },
            { id: 1005500, key: 'Sleepy', alt: '困' },
            { id: 1005600, key: 'NotEasy', alt: '不简单' },
            { id: 1005700, key: 'Embrace', alt: '拥抱' },
            { id: 1005800, key: 'OpenHand', alt: '摊手' },
            { id: 1005900, key: 'OnKnees', alt: '跪了' },
            { id: 1006000, key: 'RaiseHand', alt: '举手' },
            { id: 1006100, key: 'Hematemesis', alt: '吐血' },
            { id: 1006200, key: 'Envy', alt: '酸了' },
            { id: 1006300, key: 'SixSixSix', alt: '666' },
            { id: 1006400, key: 'EatRice', alt: '干饭' },
            { id: 1006500, key: 'Fishing', alt: '摸鱼' },
            { id: 1006600, key: 'Look', alt: '我就看看' },
            { id: 1006700, key: 'Pressure', alt: '感到压力' },
            { id: 1006800, key: 'Respect', alt: '致敬' },
            { id: 1006900, key: 'Split', alt: '裂了' },
            { id: 1007000, key: 'Surprise', alt: '惊喜' },
            { id: 1007100, key: 'Watch', alt: '暗中观察' },
            { id: 1007200, key: 'Bald', alt: '头秃' },
            { id: 1007300, key: 'sick', alt: '生病' },
            { id: 1007400, key: 'busy', alt: '忙碌' },
            { id: 1007500, key: 'GoGoGo', alt: '冲鸭' },
            { id: 1007600, key: 'Clown', alt: '小丑' },
            { id: 1007700, key: 'StarEye', alt: '星星眼' },
            { id: 1007800, key: 'Aaa', alt: '啊' },
            { id: 1007900, key: 'Embarrassed', alt: '尴尬' },
            { id: 1008000, key: 'Upset', alt: '难过' },
            { id: 1008100, key: 'Haggard', alt: '憔悴' },
            { id: 1008200, key: 'UglyRefuse', alt: '丑拒' },
            { id: 1008300, key: 'MoveBricks', alt: '搬砖' },
            { id: 1008400, key: 'BackPot', alt: '背锅' },
            { id: 1008500, key: 'HitYou', alt: '打你' },
            { id: 1008600, key: 'Humble', alt: '卑微' },
            { id: 1008700, key: 'Vengeful', alt: '记仇' },
            { id: 1008800, key: 'BiteHanky', alt: '咬手帕' },
            { id: 1008900, key: 'HandOverTea', alt: '递茶' },
            { id: 1009000, key: 'Work', alt: '工作' },
            { id: 1009100, key: 'BuddhaLike', alt: '佛了' },
            { id: 1009200, key: 'DrinkMilkTea', alt: '喝奶茶' },
            { id: 1009300, key: 'SlippedAway', alt: '溜了' },
            { id: 1009400, key: 'Excellent', alt: '顶呱呱' },
            { id: 1009500, key: 'Cheer', alt: '喝彩' },
            { id: 1009600, key: 'AddOne', alt: '+1' },
            { id: 1009625, key: 'Complete', alt: '完成' },
            { id: 1009650, key: 'TextYesV2', alt: '是' },
            { id: 1009675, key: 'TextNoV2', alt: '否' },
            { id: 1009700, key: 'KitchenKnife', alt: '菜刀' },
            { id: 1009800, key: 'Eat', alt: '吃饭' },
            { id: 1009900, key: 'Basketball', alt: '篮球' },
            { id: 1010000, key: 'Footerball', alt: '足球' },
            { id: 1010100, key: 'Coffee', alt: '咖啡' },
            { id: 1010200, key: 'Cake', alt: '蛋糕' },
            { id: 1010300, key: 'Liquor', alt: '白酒' },
            { id: 1010400, key: 'Wine', alt: '红酒' },
            { id: 1010500, key: 'Beer', alt: '啤酒' },
            { id: 1010600, key: 'AddDrumstick', alt: '加鸡腿' },
            { id: 1010700, key: 'HandHeart', alt: '比心' },
            { id: 1010800, key: 'ClapHands', alt: '拍手' },
            { id: 1010900, key: 'Praise', alt: '赞' },
            { id: 1011000, key: 'ComeOn', alt: '给力' },
            { id: 1011100, key: 'Pray', alt: '祈祷' },
            { id: 1011200, key: 'NO', alt: 'NO' },
            { id: 1011300, key: 'Rock', alt: '爱你', oldAlt: 'Rock' },
            { id: 1011400, key: 'ShakeHands', alt: '握手' },
            { id: 1011500, key: 'Victory', alt: '胜利' },
            { id: 1011600, key: 'HugFist', alt: '抱拳' },
            { id: 1011700, key: 'HookUp', alt: '勾搭' },
            { id: 1011800, key: 'OK', alt: 'OK' },
            { id: 1011850, key: 'Six', alt: '6' },
            { id: 1011900, key: 'Cat', alt: '猫猫' },
            { id: 1012000, key: 'Globefish', alt: '河豚' },
            { id: 1012100, key: 'Rabbit', alt: '兔子' },
            { id: 1012200, key: 'Chick', alt: '小鸡' },
            { id: 1012300, key: 'Rose', alt: '玫瑰' },
            { id: 1012400, key: 'Withering', alt: '凋零' },
            { id: 1012500, key: 'Love', alt: '爱心' },
            { id: 1012600, key: 'BrokenHeart', alt: '心碎' },
            { id: 1012700, key: 'Redbag', alt: '红包' },
            { id: 1012800, key: 'Congratulate', alt: '祝贺' },
            { id: 1012900, key: 'TenOutOfTen', alt: '满分' },
            { id: 1013000, key: 'calendar', alt: '日历' },
            { id: 1013100, key: 'goout', alt: '出差' },
            { id: 1013200, key: 'holiday', alt: '休假' },
            { id: 1013300, key: 'leave', alt: '离开' },
            { id: 1013400, key: 'meeting', alt: '开会' },
            { id: 1013500, key: 'plane', alt: '飞机' },
        ],
    },
];

function noUrlProtocol(url) {
    const { host, pathname } = new URL(url);
    return pathname === '/' ? host : host + pathname;
}
/**
 * 挂起语句执行给定的时间
 * @param ms 延迟时间
 * @returns
 * @example await sleep(500)
 */
const sleep = (ms) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
};
// 默认重试选项
const defaultsRetryOption = {
    interval: 1000,
    intervalGrowFactor: 1,
    maxRetries: 3,
    condition: () => true,
};
const COMMON_GROW_RETRY_OPTION = {
    interval: 1000,
    intervalGrowFactor: 2,
    maxRetries: 5,
    condition: () => true,
};
/**
 * @name retry
 * @param fn 返回执行函数
 * @param option 重试选项
 * @returns
 */
const retry = (fn, option) => __awaiter(void 0, void 0, void 0, function* () {
    const { maxRetries, condition, interval, intervalGrowFactor } = Object.assign(Object.assign({}, defaultsRetryOption), option);
    let count = 0;
    let delay = interval;
    while (true) {
        try {
            const result = yield fn(count);
            return result;
        }
        catch (e) {
            // 达到最大重试次数直接抛出异常
            if (count === maxRetries)
                throw e;
            count += 1;
            let nextable = true;
            try {
                nextable = Boolean(yield condition(e, count));
            }
            catch (e) {
                console.error('RetryConditionError', e);
            }
            // 不进行下次重试则抛出异常
            if (!nextable)
                throw e;
            delay = delay * intervalGrowFactor;
            yield sleep(delay);
        }
    }
});
function copyToClipboard(textToCopy) {
    return __awaiter(this, void 0, void 0, function* () {
        // navigator clipboard 需要https等安全上下文
        try {
            return yield navigator.clipboard.writeText(textToCopy);
        }
        catch (e) {
            console.error(e);
        }
        const isRTL = document.documentElement.getAttribute('dir') == 'rtl';
        // 创建text area
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        // Prevent zooming on iOS
        textArea.style.fontSize = '12pt';
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = 'absolute';
        textArea.style.opacity = '0';
        // textArea.style.left = "-999999px";
        textArea.style.top = '-999999px';
        textArea.style[isRTL ? 'right' : 'left'] = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // 执行复制命令并移除文本框
            document.execCommand('copy') ? res(null) : rej();
            textArea.remove();
        });
    });
}
// 服务器属性转换成驼峰命名
const camelCaseObserver = (obj) => {
    if (typeof obj !== 'object') {
        return;
    }
    for (const key in obj) {
        resolveGetSet(obj, key, obj[key]);
    }
    return obj;
};
const resolveGetSet = (obj, key, value) => {
    camelCaseObserver(value);
    const camelCaseKey = camelCase(key);
    if (camelCaseKey === key)
        return;
    Object.defineProperty(obj, camelCaseKey, {
        enumerable: true,
        configurable: true,
        get() {
            return value;
        },
        set(newVal) {
            value = newVal;
            camelCaseObserver(newVal);
        },
    });
};
/**
 * 对象驼峰键转下划线
 * 用于发出请求前进行转换（接口字段命名不规范场景慎用）
 */
const toSnakeCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => (isObject(v) ? toSnakeCase(v) : v));
    }
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [snakeCase(k), isObject(v) ? toSnakeCase(v) : v]));
};
/**
 * @description 缓存结果函数，避免重复查找，提升效率
 * @param { Function } 需要缓存结果的函数
 * @author 晋玮
 */
function cachedFn(fn) {
    const cache = Object.create(null);
    return function _cachedFn(str) {
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * 判断是否safari浏览器
 */
function isSafari() {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}
// 获取多语言
const t = (key, options) => {
    return t$1(`${key}`, options);
};
function getCookie(name) {
    const cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
        const cookiePair = cookieArr[i].split('=');
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}
let _lang;
/** 空串代表设置了自定义locale的情况 */
function setLang(defaultLang) {
    _lang = defaultLang;
}
// 获取语言参数的优先级规则 url:lang => cookie:xz_lang => cookie:lang => cookie:ulocale => navigator:language
function getLang() {
    if (typeof _lang !== 'undefined')
        return _lang;
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('lang') && urlParams.get('lang')) {
        _lang = urlParams.get('lang');
        return _lang;
    }
    const cookieXzLang = getCookie('xz_lang');
    if (cookieXzLang) {
        _lang = cookieXzLang;
        return _lang;
    }
    const cookieLang = getCookie('lang');
    if (cookieLang) {
        _lang = cookieLang;
        return _lang;
    }
    const cookieUlocale = getCookie('ulocale');
    if (cookieUlocale) {
        _lang = cookieUlocale;
        return _lang;
    }
    _lang = navigator.language;
    return _lang;
}

// export const emotionDir = 'emotion'
const findEmojiByAlt = cachedFn((alt) => {
    const icons = emotions.emoji[0].icons;
    const ico = find(icons, (ico) => {
        // 存在更新alt的情况，旧版本的alt放在oldAlt，用来显示旧的消息
        if (ico.alt === alt || ico.oldAlt === alt) {
            return true;
        }
        return false;
    });
    return ico;
});
const parse = (conf) => {
    //获取图片basePublic
    const emotionDir = `${getImgPublic()}/emotion`;
    let list = [...conf];
    list = list.map((emotion) => {
        const { name, version, logo, ext, coverVersion } = emotion;
        if (emotion.type !== EmotionType.OFFICIAL_STICKER && emotion.type !== EmotionType.OFFICIAL_JXM) {
            const uri = `${emotionDir}/${name}/v${version}`;
            const coverUri = `${emotionDir}/${name}/v${coverVersion}`;
            emotion.logo = `${uri}/${logo}`;
            emotion.icons = emotion.icons.map((ico) => {
                ico.src = `${uri}/${ico.key}.${ext}`;
                if (coverVersion) {
                    ico.coverSrc = `${coverUri}/${ico.key}.${ext}`;
                }
                return ico;
            });
        }
        else {
            emotion.logo = `${emotionDir}/${name}/v${version}/${logo}`;
            emotion.icons = emotion.icons.map((icon) => {
                icon.type = `image/${emotion.ext}`;
                if (emotion.type === EmotionType.OFFICIAL_JXM) {
                    icon.size = { w: 120, h: 120 };
                }
                else {
                    icon.size = { w: 80, h: 80 };
                }
                return icon;
            });
        }
        return emotion;
    });
    return list;
};
const emoji = parse(emoji$1);
const emotions = {
    emoji,
};
//加载完环境再解析表情地址
const parseEmoji = () => {
    emotions.emoji = parse(emoji$1);
};

var ERR_TYPE;
(function (ERR_TYPE) {
    ERR_TYPE["SERVICE_ERROR"] = "SERVICE_ERROR";
    ERR_TYPE["NETWORK_ERROR"] = "NETWORK_ERROR";
})(ERR_TYPE || (ERR_TYPE = {}));
var ELocaleLang;
(function (ELocaleLang) {
    ELocaleLang["zhCN"] = "zh-CN";
    ELocaleLang["zhTW"] = "zh-TW";
    ELocaleLang["enUS"] = "en-US";
})(ELocaleLang || (ELocaleLang = {}));

var zhCN = {
  personal_card_set_status: '设置你的工作状态',
  personal_card_dept: '部门',
  personal_card_email: '邮箱',
  personal_card_phone: '手机',
  personal_card_self_hide: '已设置隐藏',
  personal_card_hide: '对方已设置隐藏',
  personal_card_schedule: '日程',
  personal_card_see_schedule: '查看日程',
  personal_card_location: '地点',
  personal_card_send_message: '发消息',
  personal_card_video_call: '通话',
  personal_card_remark: '备注名',
  personal_card_set_remark: '设置对方的备注名',
  personal_card_alias_group: '群昵称',
  personal_card_position: '职务',
  personal_card_reports_to: '直属上级',
  personal_card_alias: '别名',
  personal_card_account: '账号',
  personal_card_employee_number: '工号',
  personal_card_no_support_tips: '不支持与外部联系人聊天',
  personal_card_sex_male: '男',
  personal_card_sex_female: '女',
  personal_card_unknown: '保密',
  personal_card_computer_online: '电脑设备在线',
  personal_card_phone_online: '手机设备在线',
  personal_card_offline: '所有设备离线',
  personal_card_copy_success: '复制成功',
  personal_card_enterprise: '企业',
  personal_card_add_as_contact: '申请添加为联系人',
  personal_card_accept: '同意添加为联系人',
  personal_card_permission_denied: '您的操作权限不足',
  personal_card_file_not_exists: '文件（夹）不存在',
  personal_card_chat_not_exists: '群聊已解散',
  personal_card_msg_not_exists: '当前消息已失效',
  personal_card_unsupported_msg_type: '暂不支持该类型消息',
  personal_card_app_event_msg_handled: '已处理',
  personal_card_invalid_user: '帐号异常',
  personal_card_token_expired: '群链接&群二维码已过期',
  personal_card_inviter_not_in_chat: '分享该群的用户已退群',
  personal_card_recall_msg_unforward: '消息已被撤回无法转发',
  personal_card_nofind_forward_msg: '转发失败，原消息已不存在',
  personal_card_user_not_exists: '用户不存在',
  personal_card_secure_file_cross_auth: '操作失败，非安全文档所属成员',
  personal_card_not_contact_relation: '不支持与非联系人发起聊天',
  personal_card_err_insufficient_card_callback_arguments: '输入不能为空',
  personal_card_err_invalid_card_callback_arguments: '入参错误',
  personal_card_err_apply_already_handled: '申请已处理',
  personal_card_chat_robot_not_exists: '该群聊机器人已被移除',
  personal_card_already_contact: '已经是联系人了',
  personal_card_user_not_in_company: '不支持转让至外部联系人',
  personal_card_no_in_contacts: '不支持对{orgType}外的人执行此操作',
  personal_card_robot_desc: '简介',
  personal_card_robot_own_corp: '所属组织',
  personal_card_robot_open_app: '打开应用',
  personal_card_robot_corp_app: '系统应用',
  personal_card_robot_open_plate_app: '开发平台应用',
  personal_card_robot_team_id: '团队号',
  personal_card_robot_isv: '服务商应用',
  personal_card_robot_responser: '负责人',
  personal_card_robot_developer: '所有者',
  personal_card_user_personal_user: '个人用户',
  personal_card_user_click_view: '点击查看',
  personal_card_user_hidden: '隐藏显示',
  personal_card_user_turn_display: '开启显示，他人可见',
  personal_card_user_memo: '备注',
  personal_card_user_view_history: '查看历史消息',
  personal_card_user_copy: '复制',
  personal_card_user_away: '电脑设备离开',
  personal_card_tag_external: '外部',
  personal_card_tag_delete: '已删除',
  personal_card_telephone: '电话',
  personal_card_add_contact: '添加联系人',
  personal_card_already_friends: '已经是好友关系了',
  personal_card_application_expired: '该申请已失效',
  personal_card_already_external_contact: '已经是外部联系人了',
  general_err_network: '网络异常，请稍后再试',
  user_hint_external_contact_basic_limit: '基础套餐企业无法使用该功能，请联系管理员'
};

var zhTW = {
  personal_card_set_status: '設置你的工作狀態',
  personal_card_dept: '部門',
  personal_card_email: '電子郵件',
  personal_card_phone: '手機',
  personal_card_self_hide: '已設置隱藏',
  personal_card_hide: '對方已設置隱藏',
  personal_card_schedule: '行程',
  personal_card_see_schedule: '檢視行程',
  personal_card_location: '地點',
  personal_card_send_message: '傳送訊息',
  personal_card_video_call: '通話',
  personal_card_remark: '備註名',
  personal_card_set_remark: '設置對方的備註名',
  personal_card_alias_group: '群組暱稱',
  personal_card_position: '職務',
  personal_card_reports_to: '直屬上級',
  personal_card_alias: '別名',
  personal_card_account: '帳號',
  personal_card_employee_number: '工號',
  personal_card_no_support_tips: '不支援與外部聯絡人聊天',
  personal_card_sex_male: '男',
  personal_card_sex_female: '女',
  personal_card_unknown: '保密',
  personal_card_computer_online: '電腦設備在線',
  personal_card_phone_online: '手機設備在線',
  personal_card_offline: '所有設備離線',
  personal_card_copy_success: '複製成功',
  personal_card_enterprise: '企業',
  personal_card_add_as_contact: '申請加為聯絡人',
  personal_card_accept: '同意加為聯絡人',
  personal_card_permission_denied: '您的操作權限不足',
  personal_card_file_not_exists: '檔案（夾）不存在',
  personal_card_chat_not_exists: '群聊已解散',
  personal_card_msg_not_exists: '當前訊息已失效',
  personal_card_unsupported_msg_type: '暫不支援該類型訊息',
  personal_card_app_event_msg_handled: '已處理',
  personal_card_invalid_user: '帳號異常',
  personal_card_token_expired: '群鏈接&群二維碼已過期',
  personal_card_inviter_not_in_chat: '分享該群的使用者已退群',
  personal_card_recall_msg_unforward: '訊息已被撤回無法轉發',
  personal_card_nofind_forward_msg: '',
  personal_card_user_not_exists: '用戶不存在',
  personal_card_secure_file_cross_auth: '操作失敗，非安全文件所屬成員',
  personal_card_not_contact_relation: '不支援與非聯絡人發起聊天',
  personal_card_err_insufficient_card_callback_arguments: '輸入不能為空',
  personal_card_err_invalid_card_callback_arguments: '輸入參數無效',
  personal_card_err_apply_already_handled: '申請已處理',
  personal_card_chat_robot_not_exists: '該群聊機器人已被移除',
  personal_card_already_contact: '已經是聯絡人了',
  personal_card_user_not_in_company: '不支持轉讓至外部聯絡人',
  personal_card_no_in_contacts: '不支持對{orgType}外的人執行此操作',
  personal_card_robot_desc: '簡介',
  personal_card_robot_own_corp: '所屬組織',
  personal_card_robot_open_app: '開啟應用',
  personal_card_robot_corp_app: '企業應用',
  personal_card_robot_open_plate_app: '開放平台應用',
  personal_card_robot_team_id: '團隊號',
  personal_card_robot_isv: '服務商應用',
  personal_card_robot_responser: '負責人',
  personal_card_robot_developer: '所有者',
  personal_card_user_personal_user: '個人使用者',
  personal_card_user_click_view: '點擊檢視',
  personal_card_user_hidden: '隱藏顯示',
  personal_card_user_turn_display: '開啟顯示，他人可見',
  personal_card_user_memo: '備註',
  personal_card_user_view_history: '檢視歷史訊息',
  personal_card_user_copy: '複製',
  personal_card_user_away: '離開電腦',
  personal_card_tag_external: '外部',
  personal_card_tag_delete: '已刪除',
  personal_card_telephone: '電話號碼',
  personal_card_add_contact: '新增聯絡人',
  personal_card_already_friends: '已加為好友',
  personal_card_application_expired: '該申請已失效',
  personal_card_already_external_contact: '已成為外部聯絡人',
  general_err_network: '網路異常，請稍後再試',
  user_hint_external_contact_basic_limit: '採用基礎方案的企業無法使用該功能，請與管理員聯繫'
};

var enUS = {
  personal_card_set_status: 'Set your work status',
  personal_card_dept: 'Dept.',
  personal_card_email: 'Email',
  personal_card_phone: 'Phone No.',
  personal_card_self_hide: 'Hidden',
  personal_card_hide: 'Hidden',
  personal_card_schedule: 'Schedule',
  personal_card_see_schedule: 'View details',
  personal_card_location: 'Location',
  personal_card_send_message: 'Message',
  personal_card_video_call: 'Call',
  personal_card_remark: 'Remark',
  personal_card_set_remark: 'Click to set remark',
  personal_card_alias_group: 'Alias in Group ',
  personal_card_position: 'Position',
  personal_card_reports_to: 'Reports to',
  personal_card_alias: 'Alias',
  personal_card_account: 'Account',
  personal_card_employee_number: 'Employee Number',
  personal_card_no_support_tips: 'Cannot chat with external contacts',
  personal_card_sex_male: 'Male',
  personal_card_sex_female: 'Female',
  personal_card_unknown: 'Unknown',
  personal_card_computer_online: 'Online on computer',
  personal_card_phone_online: 'Online on phone',
  personal_card_offline: 'Offline',
  personal_card_copy_success: 'Copied successfully',
  personal_card_enterprise: 'Company',
  personal_card_add_as_contact: 'Add as Contact',
  personal_card_accept: 'Accept',
  personal_card_permission_denied: "You don't have the required operation permissions",
  personal_card_file_not_exists: 'The file/folder does not exist',
  personal_card_chat_not_exists: 'The group chat has been dissolved',
  personal_card_msg_not_exists: 'The current message has expired',
  personal_card_unsupported_msg_type: 'This type of message is not supported',
  personal_card_app_event_msg_handled: 'Processed',
  personal_card_invalid_user: 'Account exception',
  personal_card_token_expired: 'The group link and QR code have expired',
  personal_card_inviter_not_in_chat: 'The user who shared this group has left',
  personal_card_recall_msg_unforward: 'The message has been recalled and cannot be forwarded',
  personal_card_nofind_forward_msg: '',
  personal_card_user_not_exists: 'The user does not exist',
  personal_card_secure_file_cross_auth: 'Operation failed for not being a member of the secure document.',
  personal_card_not_contact_relation: 'Starting a chat with non-contacts is not supported',
  personal_card_err_insufficient_card_callback_arguments: 'The input cannot be empty',
  personal_card_err_invalid_card_callback_arguments: 'Invalid input parameter',
  personal_card_err_apply_already_handled: 'The request has been processed',
  personal_card_chat_robot_not_exists: 'The group chat bot has been removed',
  personal_card_already_contact: 'You are already a contact',
  personal_card_user_not_in_company: 'Transferring to external contacts is not supported',
  personal_card_no_in_contacts: 'This operation is not supported for people outside the {orgType}',
  personal_card_robot_desc: 'Introduction',
  personal_card_robot_own_corp: 'Organization',
  personal_card_robot_open_app: 'Open Application',
  personal_card_robot_corp_app: 'Company Application',
  personal_card_robot_open_plate_app: 'Open Platform Application',
  personal_card_robot_team_id: 'Team Number',
  personal_card_robot_isv: 'Service Provider Application',
  personal_card_robot_responser: 'Person in Charge',
  personal_card_robot_developer: 'Owner',
  personal_card_user_personal_user: 'Personal User',
  personal_card_user_click_view: 'Click to view',
  personal_card_user_hidden: 'Hide this from others',
  personal_card_user_turn_display: 'Show this to others',
  personal_card_user_memo: 'Request',
  personal_card_user_view_history: 'View Message History',
  personal_card_user_copy: 'Copy',
  personal_card_user_away: 'Away',
  personal_card_tag_external: 'External',
  personal_card_tag_delete: 'Deleted',
  personal_card_telephone: 'Phone number',
  personal_card_add_contact: 'Add Contact',
  personal_card_already_friends: 'You are already friends',
  personal_card_application_expired: 'This application has expired',
  personal_card_already_external_contact: 'Already an external contact',
  general_err_network: 'Network error. Try again later.',
  user_hint_external_contact_basic_limit: 'Companies with the basic plan cannot use this feature, please contact the administrator.'
};

const BASE_URL = g.serviceURL(SVR.WOA);
const API_PREFIX = 'api/v1'; // API前缀
const API_V2 = `api/v2`;
const LS_LAST_SIGNIN_TIME_KEY = 'KSXZ_LAST_SIGNIN_TIME';
var EDeepType;
(function (EDeepType) {
    EDeepType["CHAT"] = "CHAT_LINK";
    EDeepType["MEETING"] = "MEETING_LINK";
})(EDeepType || (EDeepType = {}));
var EDeepLink;
(function (EDeepLink) {
    EDeepLink["CHAT_LINK"] = "woa://woa.wps.cn/chat";
    EDeepLink["MEETING_LINK"] = "woa://woa.wps.cn/nativeapp";
})(EDeepLink || (EDeepLink = {}));
const NAMESPACE_PREFIX = 'Woa';
noUrlProtocol(g.serviceURL(SVR.WOA));
const langMap = {
    [ELocaleLang.zhCN]: zhCN,
    [ELocaleLang.zhTW]: zhTW,
    [ELocaleLang.enUS]: enUS,
};
const ORGANIZATION_TYPE_TEXT_KEY = 'ORGANIZATION_TYPE_TEXT';
const EXT_CONTACT_INVITE_PATH = `/page/contact/invite`;

let Env = class Env extends Vue$1 {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.env = {};
    }
    mounted() {
        this.getEnv();
    }
    getEnv() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.xOrigin)
                    getter._xOrigin_ = this.xOrigin;
                this.env = yield getter();
                if (this.env && ((_b = (_a = this.env) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.release) !== 'default') {
                    const { xOrigin } = this.env;
                    delete this.env['xOrigin'];
                    // 更新网关
                    yield updateConfig(this.env);
                    // 更新图片public static
                    updateImgPublic(xOrigin);
                    parseEmoji();
                }
                // TODO: 获取lang后切换lang
                // eslint-disable-next-line
            }
            catch (error) {
                return error;
            }
            finally {
                this.loading = false;
            }
            this.$emit('loaded', this.env);
        });
    }
    // @ts-ignore
    render(h) {
        return this.loading
            ? h('div', { props: { size: 's' } })
            : (this.$slots.default && this.$slots.default[0]) || this.$slots.default;
    }
};
__decorate([
    Prop()
], Env.prototype, "xOrigin", void 0);
Env = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}Env`,
    })
], Env);
var script$b = Env;

/* script */
const __vue_script__$b = script$b;

/* template */

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = undefined;
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$b = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

let messageInstance = null;
// 调用方式：$message
const overrideMessage = (options) => {
    if (messageInstance) {
        messageInstance.close();
    }
    messageInstance = Message(options);
};
['error', 'success', 'info', 'warning'].forEach((type) => {
    overrideMessage[type] = (options) => {
        if (typeof options === 'string') {
            options = {
                message: options,
            };
        }
        options.type = type;
        return overrideMessage(options);
    };
});
const closeOverrideMessage = () => {
    if (messageInstance) {
        messageInstance.close();
    }
};

const typeMap = {
    'en-US': 'OrganizationType_en_US',
    'zh-CN': 'organizationType',
    'zh-TW': 'OrganizationType_zh_TW',
};
/**
 * 私网环境下，企业文案配置取于接口。
 * - 默认值为“企业”
 * @returns
 */
function getOrganizationTypeText(type = ELocaleLang.zhCN) {
    try {
        const _type = typeMap[type];
        const textMap = JSON.parse(window.sessionStorage.getItem(ORGANIZATION_TYPE_TEXT_KEY));
        return textMap[_type] || t('personal_card_enterprise');
    }
    catch (err) {
        console.error('can not match OrganizationType', err);
        return t('personal_card_enterprise');
    }
}
function setOrganizationTypeText(payload) {
    window.sessionStorage.setItem(ORGANIZATION_TYPE_TEXT_KEY, JSON.stringify(payload));
}

// export const NOT_SUPPORT_FUNC = `此功能暂不支持网页端操作，请使用${process.env.desktopName}客户端`
// export const NETWORK_ERR = '网络异常，请稍后再试'
const NETWORK_ERR_DEFAULT = '网络异常';
const SERVER_ERR_DEFAULT = '获取服务器信息失败';
const ERROR_DEFAULT = '出现异常，请稍后再试'; // 原文案为：服务器正在开小差，请稍后再试
// 服务端错误枚举
var SERVER_ERROR;
(function (SERVER_ERROR) {
    // 未开通 WOA
    SERVER_ERROR["COMPANY_LIMIT"] = "userCompanyLimited";
    SERVER_ERROR["INVALID_AUTH_CODE"] = "InvalidAuthCode";
    SERVER_ERROR["COMPANY_NOT_EXIST"] = "CompanyNotExist";
    SERVER_ERROR["PHONE_NOT_EXIST"] = "PhoneNotExist";
    SERVER_ERROR["COMPANY_ACCOUNT_EXIST"] = "CompanyAccountExist";
    SERVER_ERROR["NOT_COMPANY_USER"] = "NotCompanyUser";
    SERVER_ERROR["PHONE_FORMAT_ERROR"] = "PhoneFormatError";
    SERVER_ERROR["WPS_PLUS_CORP_ERROR"] = "WpsPlusCorpError";
    SERVER_ERROR["REQUEST_TIMES_LIMIT"] = "RequestTimesLimit";
    SERVER_ERROR["WPS_PLUS_TOKEN_ERROR"] = "WpsPlusTokenError";
    SERVER_ERROR["COMPANY_USER_ACTIVE"] = "CompanyUserActive";
    SERVER_ERROR["JOIN_COMPANY_EXCEED_LIMIT"] = "JoinCompanyExceedLimit";
    SERVER_ERROR["INVALID_ARGUMENT"] = "InvalidArgument";
    SERVER_ERROR["INTERNAL_SERVER_ERROR"] = "InternalServerError";
    SERVER_ERROR["COMPANY_USER_UP_TO_LIMIT"] = "CompanyUserUpToLimit";
    SERVER_ERROR["WPS_PLUS_NO_PERMISSION"] = "WpsPlusNoPermission";
    SERVER_ERROR["INVITE_NOT_ALLOWED_ERR"] = "InviteNotAllowedErr";
    SERVER_ERROR["APPLYID_INVALID"] = "ApplyIDInvalid";
    SERVER_ERROR["API_ACCESS_DENIED"] = "ApiAccessDenied";
    // USER_NOT_IN_CORP = `UserNotInCorp`, // 离职
    SERVER_ERROR["ALREADY_CONTACT"] = "AlreadyContact";
    SERVER_ERROR["USER_NOT_IN_COMPANY"] = "UserNotInCompany";
    SERVER_ERROR["NO_IN_CONTACTS"] = "notInContacts";
})(SERVER_ERROR || (SERVER_ERROR = {}));
// 公用错误
const getError = () => {
    const lang = getLang();
    return {
        permissionDenied: t('personal_card_permission_denied'),
        fileNotExists: t('personal_card_file_not_exists'),
        chatNotExists: t('personal_card_chat_not_exists'),
        msgNotExists: t('personal_card_msg_not_exists'),
        unsupportedMsgType: t('personal_card_unsupported_msg_type'),
        appEventMsgHandled: t('personal_card_app_event_msg_handled'),
        invalidUser: t('personal_card_invalid_user'),
        tokenExpired: t('personal_card_token_expired'),
        inviterNotInChat: t('personal_card_inviter_not_in_chat'),
        recallMsgUnforward: t('personal_card_recall_msg_unforward'),
        nofindForwardMsg: t('personal_card_nofind_forward_msg'),
        UserNotExists: t('personal_card_user_not_exists'),
        secureFileCrossAuth: t('personal_card_secure_file_cross_auth'),
        NotContactRelation: t('personal_card_not_contact_relation'),
        ErrInsufficientCardCallbackArguments: t('personal_card_err_insufficient_card_callback_arguments'),
        ErrInvalidCardCallbackArguments: t('personal_card_err_invalid_card_callback_arguments'),
        ErrApplyAlreadyHandled: t('personal_card_err_apply_already_handled'),
        chatRobotNotExists: t('personal_card_chat_robot_not_exists'),
        [SERVER_ERROR.ALREADY_CONTACT]: t('personal_card_already_contact'),
        [SERVER_ERROR.USER_NOT_IN_COMPANY]: t('personal_card_user_not_in_company'),
        [SERVER_ERROR.NO_IN_CONTACTS]: t('personal_card_no_in_contacts', {
            orgType: getOrganizationTypeText(lang || undefined),
        }),
    };
};

function success(message, duration = 3000, closeCB = null) {
    messageCommon(message, 'success', duration, closeCB);
}
function warn(message, duration = 3000) {
    messageCommon(message, 'warning', duration);
}
function error(message, duration = 3000, closeCB = null) {
    messageCommon(message, 'error', duration, closeCB);
}
function info(message, duration = 3000, closeCB = null) {
    messageCommon(message, 'info', duration, closeCB);
}
function messageCommon(message, type, duration = 3000, closeCB = null) {
    overrideMessage({
        customClass: 'el-message-woa',
        message,
        type,
        duration,
        onClose: () => {
            if (closeCB) {
                closeCB();
            }
        },
    });
}
function close() {
    closeOverrideMessage();
}
/**
 * 处理response error
 * @params {any} e error
 * @params {{ [key: string]: string }} map 可供匹配的错误码对应的错误信息
 * @params {string} showErrMsg 无法匹配的默认错误信息
 */
function errorResponse(e, map = {}, showErrMsg) {
    var _a, _b, _c;
    let message = ERROR_DEFAULT;
    // 合并公共错误
    const dict = Object.assign(Object.assign({ 
        // 如果需要 parseResult，可外面传入重写 parseResult 方法，默认返回空
        parseResult(result) {
            return '';
        } }, getError()), map);
    // 通过e.detail报错
    if ((_a = e) === null || _a === void 0 ? void 0 : _a.detail) {
        const { info, type } = e.detail;
        if (type === ERR_TYPE.NETWORK_ERROR) {
            message = NETWORK_ERR_DEFAULT;
        }
        else if ((info === null || info === void 0 ? void 0 : info.result) && dict[info.result]) {
            message = dict[info.result];
        }
        else {
            message = dict.parseResult(info === null || info === void 0 ? void 0 : info.result) || showErrMsg || SERVER_ERR_DEFAULT;
        }
    }
    else if ((_c = (_b = e) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.data) {
        // 通过e.response报错，若请求未用detail封装，则会只返回response内容
        const { result } = e.response.data;
        if (result && dict[result]) {
            message = dict[result];
        }
        else {
            message = showErrMsg || SERVER_ERR_DEFAULT;
        }
    }
    error(message, 3000, null);
}
var toast = {
    success,
    warn,
    error,
    errorResponse,
    info,
    close,
};

var Api;
(function (Api) {
    function recordSignInTime() {
        const timestamp = new Date().valueOf().toString();
        localStorage.setItem(LS_LAST_SIGNIN_TIME_KEY, timestamp);
    }
    function signIn() {
        const options = {
            retry: {
                retries: Number.MAX_SAFE_INTEGER,
                retryCondition: (e) => !e.response,
                retryDelay: () => 800,
            },
            skipAuthRefresh: true,
            autoGoSignIn: false,
        };
        return axios.post('checkin', void 0, options).finally(recordSignInTime);
    }
    Api.signIn = signIn;
})(Api || (Api = {}));
let _authorize = null;
var Kit;
(function (Kit) {
    // 默认参数
    Kit.DEFAULT_AUTHORIZE_OPTION = {
        autoSignOut: true,
        autoGoSignIn: true,
    };
    function authorize(option) {
        return __awaiter(this, void 0, void 0, function* () {
            // 避免同时发出不必要的请求
            if (_authorize)
                return _authorize;
            _authorize = retry(() => Api.signIn(), Object.assign(Object.assign({}, COMMON_GROW_RETRY_OPTION), { condition(e) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const status = get$1(e, 'response.status', 0);
                        if (status >= 400 && status < 500) {
                            return false;
                        }
                        // 若状态码不为 40X 则继续重试
                        else
                            return true;
                    });
                } }))
                .catch((e) => __awaiter(this, void 0, void 0, function* () {
                throw e;
            }))
                .finally(() => (_authorize = null));
            return _authorize;
        });
    }
    Kit.authorize = authorize;
})(Kit || (Kit = {}));

const CSRF_COOKIE_NAME = 'csrf';
const generateCSRFToken = () => {
    let token = '';
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const maxPos = chars.length;
    for (let i = 0; i < 32; i++) {
        token += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return token;
};
const getCSRFToken = () => {
    let csrf = cookies.get(CSRF_COOKIE_NAME);
    if (csrf)
        return csrf;
    else {
        csrf = generateCSRFToken();
        cookies.set(CSRF_COOKIE_NAME, csrf);
        return csrf;
    }
};

const defaultsOptions = {
    service: {
        name: 'woa',
        prefix: API_PREFIX,
    },
    csrftoken: () => !('require' in window) && getCSRFToken(),
    origin: BASE_URL,
    config: {
        autoGoSignIn: true,
        retry: {
            retries: 3,
            retryDelay: (count) => count * 200,
        },
        caseRules: false,
        transformResponse: [
            function responseToCamelCaseObserver(data) {
                if (this.disableToCamelCaseResp)
                    return data;
                camelCaseObserver(data);
                return data;
            },
        ],
    },
};
const instance = createApiClient(defaultsOptions, g);
function handleServerError(e) {
    const errResult = get$1(e, 'response.data.result') || '';
    switch (errResult) {
        // case SERVER_ERR.NOT_LOGIN:
        //   return refreshAuth(e)
        default:
            return Promise.reject(e);
    }
}
instance.interceptors.response.use((res) => {
    return res;
}, (e) => {
    if (e.isAxiosError && e.response) {
        return handleServerError(e);
    }
    return Promise.reject(e);
});
axios$1.CancelToken;
var axios = instance;
axios$1.isCancel;
axios$1.isAxiosError;

function getOrganizationTypeTextFromRemote() {
    const key = 'copywriting';
    return axios.get(`conf/${key}`);
}
// 根据 wpsuid 获取手机号
function getUserPhoneByWpsUid(wpsuid) {
    return axios.get(`wpsuser/${wpsuid}/phone`);
}
// 修改他人备注
function updateMarkname(value, targetUserid) {
    return axios.put(`users/nickname`, {
        nickname: [
            {
                type: 1,
                key: targetUserid,
                value,
            },
        ],
    });
}
// 设置用户字段信息显示
function setUsersInfo(field, on) {
    return axios.put(`users/setting`, [
        {
            field,
            on,
        },
    ]);
}
// 获取用户信息
function getContacts(uids) {
    return axios.get(`/contacts?userids=${uids.join(',')}`, {
        service: {
            prefix: API_V2,
        },
    });
}
/** 获取用户信息（支持企业用户&非企业用户） */
function getBusinessCardData(params) {
    const { userid, id_type, chat_id } = params;
    return axios.get(`/wpsuser/${userid}/businesscard`, { params: { id_type, chat_id } });
}
/** 根据 wpsuid 获取用户姓名 */
function getUserNameByWpsuid(wpsuid) {
    return axios.get(`/3rd/account/user/${wpsuid}/name`);
}

/**
 * 群禁言设置状态
 */
var EGroupDisabledMsg;
(function (EGroupDisabledMsg) {
    /**
     * 允许全员发言
     */
    EGroupDisabledMsg[EGroupDisabledMsg["ENABLE_ALL_SEND_MSG"] = 1] = "ENABLE_ALL_SEND_MSG";
    /**
     * 全员禁言
     */
    EGroupDisabledMsg[EGroupDisabledMsg["DISABLE_ALL_SEND_MSG"] = 2] = "DISABLE_ALL_SEND_MSG";
    /**
     * 部分禁言
     */
    EGroupDisabledMsg[EGroupDisabledMsg["DISABLE_PORTION_SEND_MSG"] = 3] = "DISABLE_PORTION_SEND_MSG";
})(EGroupDisabledMsg || (EGroupDisabledMsg = {}));
/**
 * 聊天类型
 * 负数为盒子类型
 * -1 为团队广场，特殊化的盒子类型
 * -2 为消息助手，特殊化的盒子类型
 */
var EChatType;
(function (EChatType) {
    EChatType[EChatType["MSG_ASSISTANT"] = -2] = "MSG_ASSISTANT";
    EChatType[EChatType["TEAM_SQUARE"] = -1] = "TEAM_SQUARE";
    EChatType[EChatType["SINGLE"] = 1] = "SINGLE";
    EChatType[EChatType["GROUP"] = 2] = "GROUP";
    EChatType[EChatType["ROBOT"] = 3] = "ROBOT";
    EChatType[EChatType["FILE_GROUP"] = 4] = "FILE_GROUP";
})(EChatType || (EChatType = {}));
/**
 * 盒子类型，与chat关联时会转换成负数
 */
var EBoxType;
(function (EBoxType) {
    EBoxType[EBoxType["DEFAULT"] = 0] = "DEFAULT";
    EBoxType[EBoxType["TEAM_SQUARE"] = 1] = "TEAM_SQUARE";
    EBoxType[EBoxType["MESSAGE_ASSISTANT"] = 2] = "MESSAGE_ASSISTANT";
})(EBoxType || (EBoxType = {}));
// 侧边栏
var EChatSidebarType;
(function (EChatSidebarType) {
    EChatSidebarType["NULL"] = "";
    EChatSidebarType["TODO"] = "todo";
    EChatSidebarType["MEMBER"] = "member";
    EChatSidebarType["ROBOT"] = "robot";
    EChatSidebarType["GROUP_NOTICE"] = "chatplacard";
    EChatSidebarType["SIDEBAR_WEBVIEW"] = "sidebar-webview";
    EChatSidebarType["SIDEBAR_DOC_VIEW"] = "sidebar-doc-view";
})(EChatSidebarType || (EChatSidebarType = {}));

var EUserGender;
(function (EUserGender) {
    EUserGender["MALE"] = "male";
    EUserGender["FEMALE"] = "female";
    EUserGender["SECRECY"] = "secrecy";
})(EUserGender || (EUserGender = {}));
var EPhoneStatus;
(function (EPhoneStatus) {
    EPhoneStatus[EPhoneStatus["NOT_VISIBLE"] = 0] = "NOT_VISIBLE";
    EPhoneStatus[EPhoneStatus["VISIBLE"] = 1] = "VISIBLE";
    EPhoneStatus[EPhoneStatus["HIDDEN"] = 2] = "HIDDEN";
})(EPhoneStatus || (EPhoneStatus = {}));
var EPhoneStatusSetting;
(function (EPhoneStatusSetting) {
    EPhoneStatusSetting[EPhoneStatusSetting["ON"] = 1] = "ON";
    EPhoneStatusSetting[EPhoneStatusSetting["OFF"] = 0] = "OFF";
})(EPhoneStatusSetting || (EPhoneStatusSetting = {}));
var EOnlineStatus;
(function (EOnlineStatus) {
    EOnlineStatus[EOnlineStatus["DISABLED"] = -1] = "DISABLED";
    EOnlineStatus[EOnlineStatus["OFFLINE"] = 0] = "OFFLINE";
    EOnlineStatus[EOnlineStatus["DESKTOP_ONLINE"] = 1] = "DESKTOP_ONLINE";
    EOnlineStatus[EOnlineStatus["MOBILE_ONLINE"] = 2] = "MOBILE_ONLINE";
    EOnlineStatus[EOnlineStatus["LEAVE"] = 3] = "LEAVE";
})(EOnlineStatus || (EOnlineStatus = {}));
var ESystemFieldType;
(function (ESystemFieldType) {
    ESystemFieldType["SYSTEM"] = "system";
})(ESystemFieldType || (ESystemFieldType = {}));
var ECustomFieldType;
(function (ECustomFieldType) {
    ECustomFieldType["TEXT"] = "text";
    ECustomFieldType["URL"] = "url";
})(ECustomFieldType || (ECustomFieldType = {}));

var EMPLOYEE_STATUS;
(function (EMPLOYEE_STATUS) {
    EMPLOYEE_STATUS["NONE"] = "";
    EMPLOYEE_STATUS["ACTIVE"] = "active";
    EMPLOYEE_STATUS["NOTACTIVE"] = "notactive";
    EMPLOYEE_STATUS["DIMISSION"] = "dimission";
    EMPLOYEE_STATUS["DISABLED"] = "disabled";
})(EMPLOYEE_STATUS || (EMPLOYEE_STATUS = {}));

var EWorkStatusSettingOn;
(function (EWorkStatusSettingOn) {
    EWorkStatusSettingOn[EWorkStatusSettingOn["ON"] = 1] = "ON";
    EWorkStatusSettingOn[EWorkStatusSettingOn["OFF"] = 2] = "OFF";
})(EWorkStatusSettingOn || (EWorkStatusSettingOn = {}));
var EWorkStatusSettingField;
(function (EWorkStatusSettingField) {
    EWorkStatusSettingField[EWorkStatusSettingField["OA"] = 1] = "OA";
    EWorkStatusSettingField[EWorkStatusSettingField["MEETING"] = 2] = "MEETING";
})(EWorkStatusSettingField || (EWorkStatusSettingField = {}));
var EUseridType;
(function (EUseridType) {
    EUseridType["WOA"] = "woa";
    EUseridType["WPS"] = "wps";
})(EUseridType || (EUseridType = {}));
var EBusinessCardRelation;
(function (EBusinessCardRelation) {
    /** 本人 */
    EBusinessCardRelation["SELF"] = "self";
    /** 企业联系人（相同企业中包含对方的默认企业） */
    EBusinessCardRelation["CORP_IN_DEFAULT"] = "corp_in_default";
    /** 企业联系人（相同企业中不包含对方的默认企业） */
    EBusinessCardRelation["CORP_NOT_IN_DEFAULT"] = "corp_not_in_default";
    /** 外部联系人 */
    EBusinessCardRelation["EXT_CORP"] = "ext_corp";
    /** 关联组织 */
    EBusinessCardRelation["COMPANY_PARTNERS"] = "company_partners";
    /** 未申请外部联系人 */
    EBusinessCardRelation["EXT_CORP_NONE"] = "ext_corp_none";
    /** 已申请外部联系人 */
    EBusinessCardRelation["EXT_CORP_APPLYING"] = "ext_corp_applying";
    /** （企业查看有woauid的个人账号）个人未创建会话 */
    EBusinessCardRelation["PERSONAL_NONE"] = "personal_none";
    /** （企业查看有woauid的个人账号）个人已存在会话 */
    EBusinessCardRelation["PERSONAL_P2P_EXISTS"] = "personal_p2p_exists";
    /** （个人查看企业）普通企业用户 */
    EBusinessCardRelation["PERSONAL_CORP"] = "personal_corp";
    /** （企业查看个人）个人用户 */
    EBusinessCardRelation["PERSONAL"] = "personal";
    /** （个人查看个人）个人用户之间不存在联系人 */
    EBusinessCardRelation["PERSONAL_CONTACT_NONE"] = "personal_contact_none";
    /** （个人查看个人）个人用户存在联系人 */
    EBusinessCardRelation["PERSONAL_CONTACT_EXISTS"] = "personal_contact_exists";
})(EBusinessCardRelation || (EBusinessCardRelation = {}));
var EBusinessCardDepartmentVisible;
(function (EBusinessCardDepartmentVisible) {
    EBusinessCardDepartmentVisible[EBusinessCardDepartmentVisible["ON"] = 1] = "ON";
    EBusinessCardDepartmentVisible[EBusinessCardDepartmentVisible["OFF"] = 2] = "OFF";
})(EBusinessCardDepartmentVisible || (EBusinessCardDepartmentVisible = {}));
/** 用户权益 */
var EBusinessCardRights;
(function (EBusinessCardRights) {
    /** woa权益 */
    EBusinessCardRights["WOA"] = "woa";
    /** 企业权益 */
    EBusinessCardRights["CORP"] = "corp";
    /** 无权益 */
    EBusinessCardRights["PERSONAL"] = "personal";
})(EBusinessCardRights || (EBusinessCardRights = {}));

let CardMixin = class CardMixin extends Vue$1 {
    constructor() {
        super(...arguments);
        this.options = this.propData;
    }
    get isSelf() {
        return this.cardData.relation === EBusinessCardRelation.SELF;
    }
    get workStatus() {
        return this.cardData.workStatus;
    }
    get userid() {
        return this.cardData.userid;
    }
    get userGender() {
        if (this.cardData.gender) {
            if (this.cardData.gender === EUserGender.MALE) {
                return EUserGender.MALE;
            }
            if (this.cardData.gender === EUserGender.FEMALE) {
                return EUserGender.FEMALE;
            }
            if (this.cardData.gender === EUserGender.SECRECY) {
                return EUserGender.SECRECY;
            }
        }
        else {
            return '';
        }
    }
    get phoneHideTip() {
        return this.isSelf ? t('personal_card_self_hide') : t('personal_card_hide');
    }
    get groupNickname() {
        var _a;
        return (_a = this.cardData.chatData) === null || _a === void 0 ? void 0 : _a.nickname;
    }
    get workPlace() {
        return this.cardData.workPlace;
    }
    get showMarkname() {
        return (this.bothHasWoaRights &&
            [
                EBusinessCardRelation.COMPANY_PARTNERS,
                EBusinessCardRelation.CORP_IN_DEFAULT,
                EBusinessCardRelation.EXT_CORP,
                EBusinessCardRelation.PERSONAL_CONTACT_EXISTS,
            ].includes(this.cardData.relation));
    }
    get showGroupNickname() {
        return this.groupNickname && this.options.isEnableGroupNickname;
    }
    // 外部联系人
    get isExtCorp() {
        return this.cardData.relation === EBusinessCardRelation.EXT_CORP;
    }
    //  [企业联系人]当前用户存在对方默认企业
    get isCorpInDefault() {
        return this.cardData.relation === EBusinessCardRelation.CORP_IN_DEFAULT;
    }
    // [企业联系人关系]---当前用户存在对方默认企业
    get isCorpNotInDefault() {
        return this.cardData.relation === EBusinessCardRelation.CORP_NOT_IN_DEFAULT;
    }
    // 非联系人，但是已经提交了外部联系人的申请
    get isExtCorpApplying() {
        return this.cardData.relation === EBusinessCardRelation.EXT_CORP_APPLYING;
    }
    // 受限制登录用户，但已经存在会话
    get isPersonalP2pExists() {
        return this.cardData.relation === EBusinessCardRelation.PERSONAL_P2P_EXISTS;
    }
    // 受限制登录用户，不存在会话
    get isPersonalNone() {
        return this.cardData.relation === EBusinessCardRelation.PERSONAL_NONE;
    }
    // 非联系人，未申请外部联系人（具有白名单企业）
    get isExtCorpNone() {
        return this.cardData.relation === EBusinessCardRelation.EXT_CORP_NONE;
    }
    // 关联组织联系人
    get isCompanyPartners() {
        return this.cardData.relation === EBusinessCardRelation.COMPANY_PARTNERS;
    }
    get isCorpUser() {
        return this.cardData.corpid > 0;
    }
    get talkable() {
        return (this.bothHasWoaRights &&
            [
                EBusinessCardRelation.COMPANY_PARTNERS,
                EBusinessCardRelation.CORP_IN_DEFAULT,
                EBusinessCardRelation.EXT_CORP,
                EBusinessCardRelation.SELF,
            ].includes(this.cardData.relation));
    }
    // 展示部门或企业名
    get departName() {
        return this.isCorpInDefault || this.isSelf
            ? t('personal_card_dept')
            : this.isCorpUser
                ? t('personal_card_enterprise')
                : t('personal_card_user_personal_user');
    }
    get departNameValue() {
        if (this.isCorpInDefault || this.isSelf) {
            return this.getDepartment(this.cardData.departments);
        }
        return this.isCorpUser ? [this.cardData.corpName] : [];
    }
    // 已离职
    get isDimission() {
        return this.cardData.status === EMPLOYEE_STATUS.DIMISSION;
    }
    get cardMarkname() {
        var _a;
        return (_a = this.cardData.mark) === null || _a === void 0 ? void 0 : _a.name;
    }
    get onlineStatusObject() {
        return (this.cardData.onlineStatusFallback || {
            status: this.cardData.onlineStatus,
            fallback: this.cardData.onlineStatus,
        });
    }
    get oprHasWoaRights() {
        return this.cardData.oprRights === EBusinessCardRights.WOA;
    }
    get peerHasWoaRights() {
        return this.cardData.peerRights === EBusinessCardRights.WOA;
    }
    get bothHasWoaRights() {
        return this.oprHasWoaRights && this.peerHasWoaRights;
    }
    /**
     * @description 获取部门信息
     */
    getDepartment(departments) {
        if (!(departments === null || departments === void 0 ? void 0 : departments.length))
            return [];
        return departments
            .map((item) => {
            const deptPathArray = item.absPath.split('/');
            if (deptPathArray.length > 1)
                deptPathArray.splice(0, 1);
            return deptPathArray.join('/');
        })
            .filter(Boolean);
    }
};
__decorate([
    Prop()
], CardMixin.prototype, "cardData", void 0);
__decorate([
    Inject()
], CardMixin.prototype, "propData", void 0);
CardMixin = __decorate([
    Component
], CardMixin);
var CardMixin$1 = CardMixin;

/**
 * 外部图标
 * 使用am-icon方式，图标会异常，改为css内联svg
 */
let UserStatusTag = class UserStatusTag extends Vue$1 {
    get iconClass() {
        if (this.isDeleted)
            return 'is-deleted';
        return 'is-external';
    }
    get text() {
        if (this.isDeleted)
            return t('personal_card_tag_delete');
        return t('personal_card_tag_external');
    }
};
__decorate([
    Prop({
        default: false,
    })
], UserStatusTag.prototype, "isRobot", void 0);
__decorate([
    Prop({
        default: false,
    })
], UserStatusTag.prototype, "isDeleted", void 0);
UserStatusTag = __decorate([
    Component
], UserStatusTag);
var script$a = UserStatusTag;

/* script */
const __vue_script__$a = script$a;
/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    { staticClass: "external-tag-icon", class: _vm.iconClass },
    [_vm._v(_vm._s(_vm.text))]
  )
};
var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = "data-v-6f6ec19c";
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$a = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

let RobotName = class RobotName extends Vue$1 {
};
__decorate([
    Prop()
], RobotName.prototype, "text", void 0);
__decorate([
    Prop({
        default: false,
    })
], RobotName.prototype, "showIcon", void 0);
__decorate([
    Prop()
], RobotName.prototype, "styleCss", void 0);
__decorate([
    Prop({
        default: false,
    })
], RobotName.prototype, "partnerApp", void 0);
RobotName = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}RobotName`,
        components: {
            UserStatusTag: __vue_component__$a,
        },
        data() {
            return { botSvg };
        },
    })
], RobotName);
var script$9 = RobotName;

/* script */
const __vue_script__$9 = script$9;
/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "woa-chat-name-wraper", style: _vm.styleCss || {} },
    [
      _c(
        "span",
        { staticClass: "chat-name-text", attrs: { title: _vm.text } },
        [_vm._v(_vm._s(_vm.text))]
      ),
      _vm._v(" "),
      _vm.showIcon
        ? _c("span", {
            staticClass: "bot-icon",
            style: { "background-image": "url(" + _vm.botSvg + ")" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.partnerApp
        ? _c("UserStatusTag", { attrs: { "is-robot": true } })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = "data-v-1aa92125";
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

const reportData = (name, params) => {
    window._dw && typeof window._dw.onEvent === 'function' && window._dw.onEvent(name, params);
};
function reportDataWithLevels(levels, params) {
    if (levels.length) {
        const name = levels.join('_');
        reportData(name, params);
    }
}
// 用户卡片相关信息上报
function reportMsgClickUserCard(type, ext) {
    reportDataWithLevels(['chat', 'msgbox', 'msglist', 'click'], Object.assign({ personalcard: type }, ext));
}
// 用户卡片-申请添加联系人、同意添加联系人埋点
function onDidDwUserCard(personalcard) {
    const opt = ['chat', 'msgbox', 'msglist', 'click'];
    reportDataWithLevels(opt, { personalcard });
}
function onChatMsgboxMsglistClick(params) {
    reportDataWithLevels(['chat', 'msgbox', 'msglist', 'click'], Object.assign({}, params));
}
function onChatMsgboxMsglistShow(params) {
    reportDataWithLevels(['chat', 'msgbox', 'msglist', 'show'], Object.assign({}, params));
}

let UserCardMixin = class UserCardMixin extends Vue$1 {
    onAvatarImgLoad() {
        const avatarImg = this.$refs.avatarImg;
        if (!avatarImg || avatarImg.naturalWidth > 258 || avatarImg.naturalHeight > 258)
            return;
        avatarImg.naturalWidth > avatarImg.naturalHeight
            ? (avatarImg.style.width = '100%')
            : (avatarImg.style.height = '100%');
    }
    /**
     * 右键打开菜单
     */
    handleOpenMenu(e) {
        var _a;
        const text = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString();
        if (!text)
            return;
        this.$menu.open(e);
    }
    /**
     * @description 复制文本
     */
    handleCopyText(e, text) {
        return __awaiter(this, void 0, void 0, function* () {
            const sel = window.getSelection();
            if (!sel)
                return this.$menu.close();
            try {
                yield copyToClipboard(text || sel.toString());
                toast.success(t('personal_card_copy_success'));
                reportMsgClickUserCard('copymail');
            }
            catch (error) {
                console.error('copy error: ', error);
            }
            finally {
                this.$menu.close();
            }
        });
    }
    destroyed() {
        var _a;
        if ((_a = this.imageViewer) === null || _a === void 0 ? void 0 : _a.isShown) {
            this.imageViewer.hide();
        }
    }
};
__decorate([
    Ref()
], UserCardMixin.prototype, "$menu", void 0);
UserCardMixin = __decorate([
    Component({
        components: {
            [__vue_component__$9.extendOptions.name]: __vue_component__$9,
        },
    })
], UserCardMixin);
var UserCardMixin$1 = UserCardMixin;

const USER_PHONE_ERROR = {
    RequestReachMaxLimit: '今日查看手机号次数已达上限',
};
var SERVER_ERR;
(function (SERVER_ERR) {
    SERVER_ERR["NOT_LOGIN"] = "userNotLogin";
    SERVER_ERR["PER_DENIED"] = "permissionDenied";
    SERVER_ERR["CHAT_NOT_EXISTS"] = "chatNotExists";
    //链接禁止分享
    SERVER_ERR["LINK_FORBID"] = "lightlinkForbid";
    //链接正在预览转换
    SERVER_ERR["LINK_VERIFYING"] = "lightlinkVerifying";
    SERVER_ERR["MSG_RECALLED"] = "msgRecalled";
    SERVER_ERR["USER_NOT_IN_CHAT"] = "UserNotInThisChat";
    // 应用未开启
    SERVER_ERR["APP_DISABLED"] = "appStatusNotEnableErr";
    SERVER_ERR["NOT_CERT"] = "userNotCert";
    SERVER_ERR["FAVORITE_EXCEED_LIMIT"] = "favoriteExceedLimit";
    SERVER_ERR["FAVORITE_EXISTS"] = "favoriteExists";
})(SERVER_ERR || (SERVER_ERR = {}));

// 设置用户信息
function SetUsersInfo({ field, on }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield setUsersInfo(field, on);
            return data;
        }
        catch (error) {
            throw error;
        }
    });
}

/** 判断是否禁用语音通话（仅在同时启用会议和语音通话打包配置时调用） */
const checkCallsSwitch = () => {
    return axios.get('calls/switch');
};

let locale = class locale extends Vue$1 {
    t(...args) {
        return t.apply(this, args);
    }
};
locale = __decorate([
    Component
], locale);
var Locale = locale;

let WorkStatus = class WorkStatus extends Mixins(Locale) {
    get workStatus() {
        if (this.data) {
            return {
                emoji: findEmojiByAlt(this.data.emoji),
                text: this.data.text,
            };
        }
    }
};
__decorate([
    Prop()
], WorkStatus.prototype, "data", void 0);
__decorate([
    Prop({
        default: true,
    })
], WorkStatus.prototype, "showText", void 0);
__decorate([
    Prop()
], WorkStatus.prototype, "isSticky", void 0);
__decorate([
    Prop()
], WorkStatus.prototype, "isSelf", void 0);
__decorate([
    Prop()
], WorkStatus.prototype, "editable", void 0);
WorkStatus = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}WorkStatus`,
    })
], WorkStatus);
var script$8 = WorkStatus;

/* script */
const __vue_script__$8 = script$8;
/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: ["work-status", !_vm.showText && "hide-text"] },
    [
      _vm.workStatus && (_vm.workStatus.text || _vm.workStatus.emoji)
        ? [
            _vm.workStatus.emoji
              ? _c("img", {
                  key: _vm.data.emoji,
                  staticClass: "work-status-emoji r-emoji_img",
                  attrs: {
                    src: _vm.workStatus.emoji.coverSrc,
                    alt: "[" + _vm.workStatus.emoji.alt + "]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showText
              ? _c(
                  "span",
                  {
                    staticClass: "work-status-text",
                    class: [_vm.isSticky && "is-sticky"],
                  },
                  [_vm._v(_vm._s(_vm.workStatus.text))]
                )
              : _vm._e(),
          ]
        : _vm.editable
        ? [
            _c(
              "span",
              {
                staticClass: "work-status-text",
                class: [_vm.isSticky && "is-sticky"],
              },
              [_vm._v(_vm._s(_vm.t("personal_card_set_status")))]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
};
var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = "data-v-4de26a5f";
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

let UserCardNormal$1 = class UserCardNormal extends Mixins(CardMixin$1, Locale) {
    get themeClass() {
        return this.theme ? `is-${this.theme}` : '';
    }
    get enableUserOnlineStatus() {
        let enable = false;
        if (this.userOnlineStatus !== EOnlineStatus.DISABLED && !this.isDimission) {
            enable = true;
        }
        return enable;
    }
    get canEditWorkStatus() {
        return this.isSelf && this.options.onClickWorkStatus;
    }
    get userOnlineStatus() {
        return this.onlineStatusObject.status in EOnlineStatus
            ? this.onlineStatusObject.status
            : this.onlineStatusObject.fallback;
    }
    handleOpenMenu(e) {
        this.$emit('contextmenu', e);
    }
    getOnlineStatusTooltip() {
        let tip = '';
        switch (this.userOnlineStatus) {
            case EOnlineStatus.DESKTOP_ONLINE:
                tip = this.t('personal_card_computer_online');
                break;
            case EOnlineStatus.MOBILE_ONLINE:
                tip = this.t('personal_card_phone_online');
                break;
            case EOnlineStatus.OFFLINE:
                tip = this.t('personal_card_offline');
                break;
            case EOnlineStatus.LEAVE:
                tip = this.t('personal_card_user_away');
                break;
        }
        return tip;
    }
    getOnlineStatusIcon() {
        let icon = '';
        switch (this.userOnlineStatus) {
            case EOnlineStatus.DESKTOP_ONLINE:
                icon = 'desktop-online';
                break;
            case EOnlineStatus.MOBILE_ONLINE:
                icon = 'mobile-online';
                break;
            case EOnlineStatus.OFFLINE:
                icon = 'offline';
                break;
            case EOnlineStatus.LEAVE:
                icon = 'leave';
                break;
        }
        return icon;
    }
    // 修改工作状态
    handleEditStatus() {
        if (!this.isSelf)
            return;
        this.$emit('click');
    }
};
__decorate([
    Prop({ default: false })
], UserCardNormal$1.prototype, "show", void 0);
__decorate([
    Prop({ default: '' })
], UserCardNormal$1.prototype, "theme", void 0);
UserCardNormal$1 = __decorate([
    Component({
        data: () => ({
            EUserGender,
        }),
        components: {
            WorkStatus: __vue_component__$8,
            UserStatusTag: __vue_component__$a,
        },
    })
], UserCardNormal$1);
var script$7 = UserCardNormal$1;

/* script */
const __vue_script__$7 = script$7;
/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "user-header",
      class: [_vm.themeClass, _vm.show ? "dark-theme-show" : ""],
    },
    [
      _c(
        "div",
        {
          staticClass: "user-info-content",
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (function () {
                return false
              })()
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "user-name",
              class: _vm.themeClass,
              on: {
                contextmenu: function ($event) {
                  $event.preventDefault();
                  return _vm.handleOpenMenu($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.cardData.name))]
          ),
          _vm._v(" "),
          _vm.cardData.isExternal || _vm.isDimission
            ? _c("UserStatusTag", { attrs: { "is-deleted": _vm.isDimission } })
            : _vm._e(),
          _vm._v(" "),
          _vm.userGender
            ? _c(
                "span",
                { staticClass: "user-gender" },
                [
                  _vm.userGender === _vm.EUserGender.MALE
                    ? _c(
                        "kd-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            "visible-arrow": false,
                            content: _vm.t("personal_card_sex_male"),
                            "open-delay": 1000,
                            "popper-class": "woa-user-card-tooltip",
                            placement: "top",
                          },
                        },
                        [
                          _c("am-icon", {
                            staticClass: "header-icon gender-icon",
                            attrs: { name: "user-gender-male" },
                          }),
                        ],
                        1
                      )
                    : _vm.userGender === _vm.EUserGender.FEMALE
                    ? _c(
                        "kd-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            "visible-arrow": false,
                            content: _vm.t("personal_card_sex_female"),
                            "open-delay": 1000,
                            "popper-class": "woa-user-card-tooltip",
                            placement: "top",
                          },
                        },
                        [
                          _c("am-icon", {
                            staticClass: "header-icon gender-icon",
                            attrs: { name: "user-gender-female" },
                          }),
                        ],
                        1
                      )
                    : _vm.userGender === _vm.EUserGender.SECRECY
                    ? _c(
                        "kd-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            "visible-arrow": false,
                            content: _vm.t("personal_card_unknown"),
                            "open-delay": 1000,
                            "popper-class": "woa-user-card-tooltip",
                            placement: "top",
                          },
                        },
                        [
                          _c("am-icon", {
                            staticClass: "header-icon gender-icon",
                            attrs: { name: "user-gender-privacy1" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enableUserOnlineStatus
            ? _c(
                "span",
                { staticClass: "user-online-status" },
                [
                  _c(
                    "kd-tooltip",
                    {
                      attrs: {
                        effect: "dark",
                        "visible-arrow": false,
                        content: _vm.getOnlineStatusTooltip(),
                        "open-delay": 1000,
                        "popper-class": "woa-user-card-tooltip",
                        placement: "top",
                      },
                    },
                    [
                      _c("am-icon", {
                        staticClass: "header-icon online-icon",
                        attrs: { name: _vm.getOnlineStatusIcon() },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.workStatus || _vm.isSelf
        ? _c("WorkStatus", {
            class: ["work-status", _vm.canEditWorkStatus && "editable"],
            attrs: {
              theme: _vm.theme,
              data: _vm.workStatus,
              "is-sticky": _vm.themeClass === "is-dark",
              "is-self": _vm.isSelf,
              editable: _vm.canEditWorkStatus,
            },
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation();
                return _vm.handleEditStatus($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
};
var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = "data-v-7618d1e4";
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

/**
 * 通过Key获取对应的尺寸大小
 * @param sizeKey string
 * @param convertToNum boolean false
 * @returns number | string
 */
function getSizeByKey(sizeKey, convertToNum = false, mode) {
    var _a;
    const fontSizeMode = mode || EFontSizeMode.STANDARD;
    const sizePool = (_a = SIZE_MODE_DATA[fontSizeMode]) === null || _a === void 0 ? void 0 : _a.size;
    return getSizeTheme(sizeKey, convertToNum, sizePool);
}

function resolveGatewayUrl(url) {
    // 可能存file://和不带file的情况
    const reg = /(file:\/\/.*)?\$entry\((.+)\)\$/g;
    const result = reg.exec(url);
    if (result) {
        const name = result[2]; // 得到对应的服务
        const hasService = !!g.config.service[name];
        let replaceUrl = url;
        if (hasService) {
            replaceUrl = url.replace(/(file:\/\/.*)?\$entry\(.+\)\$/g, g.serviceURL(name));
        }
        else {
            console.error(`Service ${name} not found`);
        }
        return replaceUrl;
    }
    return url;
}

/**
 * 审批外部联系人申请
 */
const approveExtContactsApply = (applyId, approve) => {
    return axios.put(`extcontacts/applies/${applyId}`, { approve });
};

// 联系人申请状态
var EExtContactsApplyState;
(function (EExtContactsApplyState) {
    EExtContactsApplyState[EExtContactsApplyState["PENDING"] = 0] = "PENDING";
    EExtContactsApplyState[EExtContactsApplyState["APPROVE"] = 1] = "APPROVE";
    EExtContactsApplyState[EExtContactsApplyState["REJECT"] = 2] = "REJECT";
    EExtContactsApplyState[EExtContactsApplyState["INVALID"] = 3] = "INVALID";
})(EExtContactsApplyState || (EExtContactsApplyState = {}));
var EApproveApplyError;
(function (EApproveApplyError) {
    EApproveApplyError["ERR_CONTACT_APPROVE"] = "ErrContactApprove";
    EApproveApplyError["APPLYID_INVALID"] = "ApplyIDInvalid";
    EApproveApplyError["ALREADY_CONTACT"] = "AlreadyContact";
    EApproveApplyError["CORP_PACKAGE_IS_BASIC"] = "CorpPackageIsBasic";
})(EApproveApplyError || (EApproveApplyError = {}));

const observers = new WeakMap();
/**
 * 检测节点是否为空节点
 * USAGE: v-blank[.immediate]="isBlank|callback"
 */
const blankObserverDirective = {
    bind(el, binding, vnode) {
        if (observers.has(el)) {
            return;
        }
        const cb = () => {
            const isBlank = !el.childElementCount &&
                !some(el.childNodes, (node) => node instanceof Text && trim(node.textContent || ''));
            if (isFunction(binding.value)) {
                binding.value(isBlank);
                return;
            }
            const vm = vnode.context;
            const exp = binding.expression;
            exp && (vm === null || vm === void 0 ? void 0 : vm.$set(vm, exp, isBlank));
        };
        const ob = new MutationObserver(cb);
        ob.observe(el, { childList: true });
        observers.set(el, ob);
        binding.modifiers.immediate && cb();
    },
    unbind(el) {
        const ob = observers.get(el);
        if (ob) {
            ob.disconnect();
            observers.delete(el);
        }
    },
};

let UserCardNormal = class UserCardNormal extends Mixins(UserCardMixin$1, CardMixin$1, Locale) {
    constructor() {
        var _a;
        super(...arguments);
        this.showPhone = false;
        this.userPhone = '';
        // 缓存上一次保存的备注
        this.lastMarkname = ((_a = this.cardData.mark) === null || _a === void 0 ? void 0 : _a.name) || '';
        this.markname = this.lastMarkname;
        this.isMarknameEditing = false;
        // esc 关闭子 popper，编辑框内容不能保存的锁
        this.isCanSave = true;
        this.applyExtContactFinished = false; // 同意外部联系人申请完成
        this.footerBtnLoading = false;
        this.threshold = 0.95; // 滚动到顶部的阈值
        this.clickTime = 0; // 点击开始时间
        this.intersectionObserver = null;
        this.fixedUserHeaderShow = false;
        // 兼容safari浏览器滚动条
        this.safariScroll = isSafari() ? { '--thumbBgColor': 'rgba(0,0,0,.2)' } : '';
        this.fixAvatarWidth = {};
        this.isFooterBlank = false;
    }
    onCardDataChange() {
        // 名片换人时滚动到顶部，并隐藏fix顶部的用户名
        this.scroller.scrollTo(0, 0);
        // 把当前页面data的卡片数据初始化一遍
        this.showPhone = false;
        this.userPhone = '';
        this.lastMarkname = this.cardMarkname || '';
        this.markname = this.lastMarkname;
        this.isMarknameEditing = false;
        this.isCanSave = true;
        this.applyExtContactFinished = false;
        this.footerBtnLoading = false;
        this.fixedUserHeaderShow = false;
    }
    get enableSchedule() {
        return this.options && this.options.enableSchedule && this.cardData.calenderShow;
    }
    /**
     * 是否配置开启外部联系人模块
     */
    get enableExtContact() {
        return this.options.enableExtContact;
    }
    /**
     * 是否配置开启会议模块
     */
    get enableMeeting() {
        return this.options.enableMeeting && !this.isSelf;
    }
    get enableVoiceCall() {
        return this.options.enableVoiceCall && !this.isSelf;
    }
    get onlineStatus() {
        return this.onlineStatusObject.status in EOnlineStatus
            ? this.onlineStatusObject.status
            : this.onlineStatusObject.fallback;
    }
    get enableUserOnlineStatus() {
        let enable = false;
        if (this.onlineStatus !== EOnlineStatus.DISABLED) {
            enable = true;
        }
        return enable;
    }
    get canClickDep() {
        return !!this.options.onOpenDept;
    }
    get iconSize() {
        return getSizeByKey(ESizeTheme.SIZE_ICON_SIZE, true, this.options.sizeTheme);
    }
    get buttons() {
        return this.options.buttons;
    }
    mounted() {
        this.$nextTick(() => {
            var _a;
            this.intersectionObserver = new IntersectionObserver((entries) => {
                const userHeader = entries[0];
                // 判断最后一个节点是否完全曝光
                const { intersectionRatio: threshold, boundingClientRect } = userHeader;
                if (threshold < this.threshold && boundingClientRect.height) {
                    this.fixedUserHeaderShow = true;
                }
                else if (threshold >= this.threshold && this.fixedUserHeaderShow) {
                    this.fixedUserHeaderShow = false;
                }
            }, {
                threshold: [this.threshold],
                root: this.userCard,
            });
            (_a = this.intersectionObserver) === null || _a === void 0 ? void 0 : _a.observe(this.userHeader.$el);
        });
    }
    handleOpenLeaderCard() {
        var _a, _b;
        (_b = (_a = this.options).onOpenUserCard) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
    }
    handleAvatarClick() {
        this.$emit('onClickAvatar');
    }
    // 更新备注
    onUpdateMarkname() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isMarknameEditing = false;
            // esc 关闭不保存
            if (!this.isCanSave) {
                this.markname = this.lastMarkname;
                return;
            }
            this.markname = this.markname.trim();
            if (this.markname === this.lastMarkname) {
                return;
            }
            try {
                yield updateMarkname(this.markname, this.userid);
                this.options.onUpdateUserInfo &&
                    this.options.onUpdateUserInfo(Object.assign(Object.assign({}, this.cardData), { mark: Object.assign(Object.assign({}, this.cardData.mark), { name: this.markname }), markname: this.markname }));
                this.lastMarkname = this.markname;
                reportMsgClickUserCard('changeremark', {
                    remarklength: this.markname.length,
                });
            }
            catch (error) {
                this.markname = this.lastMarkname;
                toast.errorResponse(error);
            }
        });
    }
    // 更改手机号状态
    handlePhoneStatus(on) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield SetUsersInfo({ field: 'phone', on });
                if (on === EPhoneStatusSetting.ON) {
                    this.$set(this.cardData, 'phoneStatus', EPhoneStatus.VISIBLE);
                    reportMsgClickUserCard('showphone');
                }
                else if (on === EPhoneStatusSetting.OFF) {
                    this.$set(this.cardData, 'phoneStatus', EPhoneStatus.HIDDEN);
                    reportMsgClickUserCard('hiddenphone');
                    this.showPhone = false;
                }
            }
            catch (error) {
                toast.errorResponse(error);
            }
        });
    }
    // 修改备注
    handleEditMarkname() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isCanSave = true;
            this.isMarknameEditing = true;
            yield this.$nextTick();
            this.$refs.marknameInputRef.focus();
            reportMsgClickUserCard('remark');
        });
    }
    // 修改工作状态
    handleEditStatus() {
        if (!this.isSelf)
            return;
        this.$emit('onClickWorkStatus');
    }
    openPhone() {
        return __awaiter(this, void 0, void 0, function* () {
            this.userPhone = '';
            try {
                const { data: { phone }, } = yield getUserPhoneByWpsUid(this.cardData.wpsid);
                this.userPhone = phone;
                reportMsgClickUserCard('viewphone');
            }
            catch (error) {
                toast.errorResponse(error, USER_PHONE_ERROR);
            }
            this.showPhone = true;
        });
    }
    handleEscKeyDown() {
        this.isCanSave = false;
    }
    closeSubPopper() {
        this.$refs.subPopperRef.doClose();
    }
    // 同意添加为联系人
    onDidAgreeApply() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!navigator.onLine) {
                toast.error(this.t('general_err_network'));
                return;
            }
            const { onClickAgreeApply, onUpdateExtContactApply } = this.options;
            const prevented = yield (onClickAgreeApply === null || onClickAgreeApply === void 0 ? void 0 : onClickAgreeApply(this.cardData));
            if (prevented) {
                return;
            }
            const { applyId } = this.cardData;
            this.footerBtnLoading = true;
            onDidDwUserCard('add');
            try {
                yield approveExtContactsApply(applyId, EExtContactsApplyState.APPROVE);
                onUpdateExtContactApply === null || onUpdateExtContactApply === void 0 ? void 0 : onUpdateExtContactApply({ applyId: applyId, state: EExtContactsApplyState.APPROVE });
                this.applyExtContactFinished = true;
            }
            catch (e) {
                const result = (_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result;
                const states = {
                    [EApproveApplyError.APPLYID_INVALID]: EExtContactsApplyState.INVALID,
                    [EApproveApplyError.ALREADY_CONTACT]: EExtContactsApplyState.APPROVE,
                };
                const state = states[result];
                state && (onUpdateExtContactApply === null || onUpdateExtContactApply === void 0 ? void 0 : onUpdateExtContactApply({ applyId: applyId, state }));
                toast.errorResponse(e, {
                    [EApproveApplyError.ERR_CONTACT_APPROVE]: this.t('personal_card_already_friends'),
                    [EApproveApplyError.APPLYID_INVALID]: this.t('personal_card_application_expired'),
                    [EApproveApplyError.ALREADY_CONTACT]: this.t('personal_card_already_external_contact'),
                    [EApproveApplyError.CORP_PACKAGE_IS_BASIC]: this.t('user_hint_external_contact_basic_limit'),
                });
            }
            this.footerBtnLoading = false;
        });
    }
    // 申请添加为联系人
    onDidApply() {
        return __awaiter(this, void 0, void 0, function* () {
            onDidDwUserCard('apply');
            // 非白名单企业用户
            // if (this.isPersonalNone) {
            //   toast.error(`暂不支持添加未开通${this.$desktopName}企业服务的用户`)
            //   return
            // }
            this.$emit('onDidApplyExtContact');
        });
    }
    checkExtContactNoUse() {
        /**
         * !!!在外部联系人功能不可用时，以下三个关系，直接弹toast
         * 1. 已经提交了外部联系人的申请
         * 2. 受限制登录用户且不存在会话
         * 3. 未申请外部联系人关系的
         */
        return !this.enableExtContact && (this.isExtCorpApplying || this.isPersonalNone || this.isExtCorpNone);
    }
    // 发送消息
    onSendMsg() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkExtContactNoUse()) {
                toast.info(this.t('personal_card_no_support_tips'));
                return;
            }
            this.$emit('onSendMsg');
        });
    }
    // 开启会议或语音
    onJoinMeetingOrVoiceCall() {
        return __awaiter(this, void 0, void 0, function* () {
            reportMsgClickUserCard('voicecall');
            if (this.checkExtContactNoUse()) {
                toast.info(this.t('personal_card_no_support_tips'));
                return;
            }
            // 如果打包配置同时启用了会议和语音通话，那么需要通过接口判断应该使用会议还是语音通话
            let enableVoiceCall = this.enableVoiceCall;
            if (this.enableVoiceCall && this.enableMeeting) {
                try {
                    const { data } = yield checkCallsSwitch();
                    enableVoiceCall = !data.data.disable; // disable 表示是否禁用语音通话
                }
                catch (err) {
                    enableVoiceCall = this.enableVoiceCall;
                }
            }
            // 当同时启用会议和语音时，语音优先
            this.$emit(enableVoiceCall ? 'onStartVoiceCall' : 'onJoinMeeting');
        });
    }
    /**
     * @description 打开邮箱
     */
    handleOpenEmail(email) {
        reportMsgClickUserCard('sendmail');
        if (this.options.onClickEmail) {
            this.options.onClickEmail(this.cardData);
            return;
        }
        const a = document.createElement('a');
        a.href = `mailto:${email}`;
        a.target = '_blank';
        a.click();
    }
    // 打开日程
    checkBusyStatus() {
        reportMsgClickUserCard('viewschedule');
        this.$emit('checkBusyStatus');
    }
    handleMouseDown(e) {
        if (e.button === 0) {
            this.clickTime = new Date().getTime();
        }
    }
    handleOpenDept(e, index) {
        const endTime = new Date().getTime();
        // 防止拖拽时触发了点击事件
        if (endTime - this.clickTime < 300) {
            this.$emit('onOpenDept', index);
        }
    }
    handleOpenUrl(url) {
        const endTime = new Date().getTime();
        // 防止拖拽时触发了点击事件
        if (endTime - this.clickTime < 300) {
            this.$emit('onOpenUrl', resolveGatewayUrl(url));
        }
    }
    handleClickCustomButton(button) {
        button.onClick(cloneDeep(this.cardData));
    }
};
__decorate([
    Ref()
], UserCardNormal.prototype, "userHeader", void 0);
__decorate([
    Ref()
], UserCardNormal.prototype, "userCard", void 0);
__decorate([
    Ref()
], UserCardNormal.prototype, "scroller", void 0);
__decorate([
    Watch('cardData')
], UserCardNormal.prototype, "onCardDataChange", null);
UserCardNormal = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}UserNormalCard`,
        data: () => ({
            EUserGender,
            EPhoneStatus,
            EPhoneStatusSetting,
            EDeepType,
            ECustomFieldType,
        }),
        components: {
            UserHeader: __vue_component__$7,
            Copy,
            Pen,
            Eye,
            EyeClose,
        },
        directives: {
            blank: blankObserverDirective,
        },
    })
], UserCardNormal);
var script$6 = UserCardNormal;

/* script */
const __vue_script__$6 = script$6;
/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "userCard",
      staticClass: "woa-user-card-normal",
      class: { dimission: _vm.isDimission },
    },
    [
      _c("UserHeader", {
        attrs: {
          show: _vm.fixedUserHeaderShow,
          theme: "dark",
          "card-data": _vm.cardData,
        },
        on: {
          contextmenu: function ($event) {
            $event.preventDefault();
            return _vm.handleOpenMenu($event)
          },
          click: _vm.handleEditStatus,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "scroller", staticClass: "user-card__body" },
        [
          _c(
            "el-scrollbar",
            {
              staticClass: "user-card__scrollbar",
              attrs: { "wrap-class": "user-card__scrollbar-wrap" },
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _c("img", {
                  key: _vm.cardData.avatar,
                  ref: "avatarImg",
                  staticClass: "header-avatar",
                  attrs: {
                    src: _vm.cardData.avatarOrigin || _vm.cardData.avatar,
                    draggable: "false",
                    alt: "",
                  },
                  on: { load: _vm.onAvatarImgLoad },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-mask",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation();
                      return _vm.handleAvatarClick(
                        _vm.cardData.avatarOrigin || _vm.cardData.avatar
                      )
                    },
                  },
                },
                [_c("div", { staticClass: "header-mask" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "woa-card-main-wrapper" },
                [
                  _c("UserHeader", {
                    ref: "userHeader",
                    attrs: { "card-data": _vm.cardData },
                    on: {
                      contextmenu: function ($event) {
                        $event.preventDefault();
                        return _vm.handleOpenMenu($event)
                      },
                      click: _vm.handleEditStatus,
                    },
                  }),
                  _vm._v(" "),
                  !_vm.isDimission
                    ? _c(
                        "div",
                        { staticClass: "card-main" },
                        [
                          _vm.cardData.loginName
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_account"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-main__row--value",
                                    on: {
                                      contextmenu: function ($event) {
                                        $event.preventDefault();
                                        return _vm.handleOpenMenu($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.cardData.loginName) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.employeeId
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t("personal_card_employee_number")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-main__row--value",
                                    on: {
                                      contextmenu: function ($event) {
                                        $event.preventDefault();
                                        return _vm.handleOpenMenu($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.cardData.employeeId) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-main__row" }, [
                            _c("div", { staticClass: "card-main__row--name" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.departName) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-main__row--value list department",
                                on: {
                                  contextmenu: function ($event) {
                                    $event.preventDefault();
                                    return _vm.handleOpenMenu($event)
                                  },
                                },
                              },
                              [
                                _vm.isCorpInDefault || _vm.isSelf
                                  ? _vm._l(
                                      _vm.departNameValue,
                                      function (department, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            class: {
                                              field:
                                                _vm.departNameValue.length > 1,
                                              "hover-highlight pointer":
                                                _vm.canClickDep,
                                            },
                                            on: {
                                              mousedown: _vm.handleMouseDown,
                                              mouseup: function ($event) {
                                                return _vm.handleOpenDept(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(department) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  : _vm._l(
                                      _vm.departNameValue,
                                      function (department, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            class: {
                                              field:
                                                _vm.departNameValue.length > 1,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(department) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.cardData.email
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [_vm._v(_vm._s(_vm.t("personal_card_email")))]
                                ),
                                _vm._v(" "),
                                _vm.cardData.email
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-main__row--value ope email-box",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "hover-highlight pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleOpenEmail(
                                                  _vm.cardData.email
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.cardData.email))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ope-icon pointer fix-height",
                                          },
                                          [
                                            _c("Copy", {
                                              staticClass: "user-card-icon",
                                              attrs: {
                                                fill: "currentColor",
                                                size: _vm.iconSize,
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleCopyText(
                                                    $event,
                                                    _vm.cardData.email
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.phoneStatus &&
                          _vm.cardData.phoneStatus !==
                            _vm.EPhoneStatus.NOT_VISIBLE
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [_vm._v(_vm._s(_vm.t("personal_card_phone")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-main__row--value phone-box",
                                  },
                                  [
                                    _vm.cardData.phoneStatus ===
                                      _vm.EPhoneStatus.VISIBLE && !_vm.showPhone
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "hover-highlight pointer",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation();
                                                return _vm.openPhone($event)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t(
                                                  "personal_card_user_click_view"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cardData.phoneStatus ===
                                    _vm.EPhoneStatus.HIDDEN
                                      ? _c(
                                          "span",
                                          { staticClass: "placeholder" },
                                          [_vm._v(_vm._s(_vm.phoneHideTip))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.cardData.phoneStatus ===
                                      _vm.EPhoneStatus.VISIBLE && _vm.showPhone
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              contextmenu: function ($event) {
                                                $event.preventDefault();
                                                return _vm.handleOpenMenu(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.userPhone) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "kd-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          placement: "bottom",
                                          content: _vm.t(
                                            "personal_card_user_hidden"
                                          ),
                                        },
                                      },
                                      [
                                        _vm.isSelf &&
                                        _vm.oprHasWoaRights &&
                                        _vm.cardData.phoneStatus ===
                                          _vm.EPhoneStatus.VISIBLE
                                          ? _c("Eye", {
                                              staticClass:
                                                "svg-icon pointer ml4 user-card-icon",
                                              attrs: {
                                                size: _vm.iconSize,
                                                fill: "currentColor",
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handlePhoneStatus(
                                                    _vm.EPhoneStatusSetting.OFF
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "kd-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          placement: "bottom",
                                          content: _vm.t(
                                            "personal_card_user_turn_display"
                                          ),
                                        },
                                      },
                                      [
                                        _vm.isSelf &&
                                        _vm.oprHasWoaRights &&
                                        _vm.cardData.phoneStatus ===
                                          _vm.EPhoneStatus.HIDDEN
                                          ? _c("EyeClose", {
                                              staticClass:
                                                "svg-icon pointer ml4 user-card-icon",
                                              attrs: {
                                                name: "phone-number-hide",
                                                size: _vm.iconSize,
                                                fill: "currentColor",
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handlePhoneStatus(
                                                    _vm.EPhoneStatusSetting.ON
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.enableSchedule
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_schedule"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-main__row--value",
                                    on: { click: _vm.checkBusyStatus },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "hover-highlight pointer",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.t("personal_card_see_schedule")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.workPlace
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_location"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-main__row--value",
                                    on: {
                                      contextmenu: function ($event) {
                                        $event.preventDefault();
                                        return _vm.handleOpenMenu($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.workPlace) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.alias_name
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [_vm._v(_vm._s(_vm.t("personal_card_alias")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--value" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.cardData.alias_name) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.leaderName
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_reports_to"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--value" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "hover-highlight pointer",
                                        on: { click: _vm.handleOpenLeaderCard },
                                      },
                                      [_vm._v(_vm._s(_vm.cardData.leaderName))]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.title
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_position"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--value" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.cardData.title) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.telephone
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_telephone"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-main__row--value",
                                    on: {
                                      contextmenu: function ($event) {
                                        $event.preventDefault();
                                        return _vm.handleOpenMenu($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.cardData.telephone) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.cardData.custom_fields, function (field) {
                            return [
                              field.type === _vm.ECustomFieldType.URL &&
                              field.url &&
                              field.url.link
                                ? _c(
                                    "div",
                                    {
                                      key: field.id,
                                      staticClass: "card-main__row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-main__row--name" },
                                        [_vm._v(_vm._s(field.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "card-main__row--value",
                                          class: { link: field.url.link },
                                          on: {
                                            mousedown: _vm.handleMouseDown,
                                            mouseup: function ($event) {
                                              return _vm.handleOpenUrl(
                                                field.url.link
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                field.url.title ||
                                                  field.url.link
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : field.value
                                ? _c(
                                    "div",
                                    {
                                      key: field.id,
                                      staticClass: "card-main__row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-main__row--name" },
                                        [_vm._v(_vm._s(field.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "card-main__row--value",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(field.value) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                          _vm._v(" "),
                          _vm.showGroupNickname
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_alias_group"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-main__row--value overflow-hidden",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.groupNickname) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showMarkname
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_remark"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--value ope" },
                                  [
                                    _vm.isMarknameEditing
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.markname,
                                              expression: "markname",
                                            },
                                          ],
                                          ref: "marknameInputRef",
                                          staticClass: "ope-input",
                                          attrs: {
                                            maxlength: "15",
                                            autocomplete: "off",
                                            spellcheck: "false",
                                          },
                                          domProps: { value: _vm.markname },
                                          on: {
                                            blur: _vm.onUpdateMarkname,
                                            keydown: [
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  $event.keyCode !== 13
                                                ) {
                                                  return null
                                                }
                                                return $event.target.blur()
                                              },
                                              function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "esc",
                                                    27,
                                                    $event.key,
                                                    ["Esc", "Escape"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.handleEscKeyDown(
                                                  $event
                                                )
                                              },
                                            ],
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.markname = $event.target.value;
                                            },
                                          },
                                        })
                                      : _vm.markname
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ope ope-text overflow-hidden",
                                          },
                                          [_vm._v(_vm._s(_vm.markname))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ope ope-text placeholder pointer",
                                            on: {
                                              click: _vm.handleEditMarkname,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.t(
                                                    "personal_card_set_remark"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    !_vm.isMarknameEditing
                                      ? _c("Pen", {
                                          staticClass:
                                            "ope-icon pointer mt2 ml8 am-icon am-fill user-card-icon",
                                          attrs: {
                                            fill: "currentColor",
                                            size: _vm.iconSize,
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.handleEditMarkname(
                                                $event
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardData.note
                            ? _c("div", { staticClass: "card-main__row" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.t("personal_card_user_memo"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-main__row--value" },
                                  [_vm._v(_vm._s(_vm.cardData.note))]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "blank",
              rawName: "v-blank.immediate",
              value: _vm.isFooterBlank,
              expression: "isFooterBlank",
              modifiers: { immediate: true },
            },
          ],
          staticClass: "card-footer",
          class: { blank: _vm.isFooterBlank },
        },
        [
          _vm.oprHasWoaRights && _vm.isPersonalP2pExists
            ? _c(
                "el-button",
                {
                  staticClass: "button",
                  attrs: { type: "primary" },
                  on: { click: _vm.onSendMsg },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.t("personal_card_user_view_history")) +
                      "\n    "
                  ),
                ]
              )
            : _vm.enableExtContact &&
              _vm.isExtCorpApplying &&
              !_vm.applyExtContactFinished
            ? _c(
                "el-button",
                {
                  staticClass: "button",
                  attrs: { type: "primary", loading: _vm.footerBtnLoading },
                  on: { click: _vm.onDidAgreeApply },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.t("personal_card_accept")) +
                      "\n    "
                  ),
                ]
              )
            : _vm.enableExtContact && _vm.bothHasWoaRights && _vm.isExtCorpNone
            ? _c(
                "el-button",
                {
                  staticClass: "button",
                  attrs: { type: "primary", loading: _vm.footerBtnLoading },
                  on: { click: _vm.onDidApply },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.t("personal_card_add_as_contact")) +
                      "\n    "
                  ),
                ]
              )
            : _vm.talkable ||
              (_vm.bothHasWoaRights && _vm.applyExtContactFinished)
            ? [
                _vm.enableMeeting || _vm.enableVoiceCall
                  ? _c(
                      "div",
                      {
                        staticClass: "button voice-btn",
                        on: { click: _vm.onJoinMeetingOrVoiceCall },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.t("personal_card_video_call")) +
                              " "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "button",
                    attrs: { type: "primary" },
                    on: { click: _vm.onSendMsg },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        " " + _vm._s(_vm.t("personal_card_send_message")) + " "
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.buttons
            ? _vm._l(_vm.buttons, function (button) {
                return _c(
                  "div",
                  {
                    key: button.label,
                    staticClass: "button custom-button",
                    class: button.type,
                    on: {
                      click: function ($event) {
                        return _vm.handleClickCustomButton(button)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(button.label) + "\n      ")]
                )
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "woa-vue-context",
        { ref: "$menu", staticClass: "card-vue-context" },
        [
          [
            _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript:;", draggable: "false" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault();
                      $event.stopPropagation();
                      return _vm.handleCopyText($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.t("personal_card_user_copy")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ],
        ],
        2
      ),
    ],
    1
  )
};
var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = "data-v-dc33441e";
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

// 群聊机器人类型
var EGroupRobotType;
(function (EGroupRobotType) {
    EGroupRobotType[EGroupRobotType["WEBHOOK"] = 0] = "WEBHOOK";
    EGroupRobotType[EGroupRobotType["DUTY"] = 1] = "DUTY";
    EGroupRobotType[EGroupRobotType["APP"] = 2] = "APP";
    EGroupRobotType[EGroupRobotType["HELPDESK"] = 3] = "HELPDESK";
})(EGroupRobotType || (EGroupRobotType = {}));
// 机器人卡片类型
var EChatRobotType;
(function (EChatRobotType) {
    EChatRobotType[EChatRobotType["GROUP"] = 1] = "GROUP";
    EChatRobotType[EChatRobotType["SINGLE"] = 2] = "SINGLE";
})(EChatRobotType || (EChatRobotType = {}));
// 机器人类型
var ERobotType;
(function (ERobotType) {
    ERobotType[ERobotType["DEFAULT"] = -1] = "DEFAULT";
    ERobotType[ERobotType["CORP"] = 0] = "CORP";
    ERobotType[ERobotType["OPEN"] = 1] = "OPEN";
    ERobotType[ERobotType["WOA"] = 2] = "WOA";
    ERobotType[ERobotType["PROXY"] = 3] = "PROXY";
    ERobotType[ERobotType["SUBSCRIPTION"] = 4] = "SUBSCRIPTION";
    ERobotType[ERobotType["ISV"] = 6] = "ISV";
    ERobotType[ERobotType["ISV_TEST"] = 7] = "ISV_TEST";
})(ERobotType || (ERobotType = {}));
var EVisiableRole;
(function (EVisiableRole) {
    EVisiableRole["DEVELOPER"] = "\u6240\u6709\u8005";
    EVisiableRole["RESPONSER"] = "\u8D1F\u8D23\u4EBA";
})(EVisiableRole || (EVisiableRole = {}));

/**
 * 获取群机器人详情
 * @param {number} chatid 会话ID
 * @param {number} robotid 机器人ID
 */
function getGroupRobotDetail(chatid, robotid, status) {
    return axios.get(`chats/${chatid}/robots/${robotid}`, {
        params: {
            status,
        },
    });
}
/**
 * 获取单聊机器人信息
 * @param chatid
 * @returns
 */
function getSingleRobotInfo(chatid) {
    return axios.get(`chats/${chatid}/meta`);
}

// 企业应用打开方式
var EAppOpenType;
(function (EAppOpenType) {
    EAppOpenType[EAppOpenType["INSIDE"] = 0] = "INSIDE";
    EAppOpenType[EAppOpenType["OUTSIDE"] = 1] = "OUTSIDE";
})(EAppOpenType || (EAppOpenType = {}));
var EMenuType;
(function (EMenuType) {
    EMenuType[EMenuType["URL"] = 0] = "URL";
    EMenuType[EMenuType["MSG"] = 1] = "MSG";
})(EMenuType || (EMenuType = {}));
// 企业应用列表请求参数
var EAppOpenStatus;
(function (EAppOpenStatus) {
    EAppOpenStatus[EAppOpenStatus["PC"] = 0] = "PC";
    EAppOpenStatus[EAppOpenStatus["MOBILE"] = 1] = "MOBILE";
})(EAppOpenStatus || (EAppOpenStatus = {}));

// 应用状态
var EAppRobotStatus;
(function (EAppRobotStatus) {
    EAppRobotStatus[EAppRobotStatus["OPEN"] = 0] = "OPEN";
    EAppRobotStatus[EAppRobotStatus["CLOSE"] = 1] = "CLOSE";
    EAppRobotStatus[EAppRobotStatus["DELETE"] = 2] = "DELETE";
})(EAppRobotStatus || (EAppRobotStatus = {}));
// 当前用户与应用的关系
var EAppRoleType;
(function (EAppRoleType) {
    EAppRoleType["OWNER"] = "owner";
    EAppRoleType["ADMIN"] = "admin";
    EAppRoleType["NORMAL"] = "normal";
    EAppRoleType["UNKNOWN"] = "unknown";
})(EAppRoleType || (EAppRoleType = {}));
var ESearchStatus;
(function (ESearchStatus) {
    ESearchStatus["ADDED"] = "added";
    ESearchStatus["UNADDED"] = "unadded";
})(ESearchStatus || (ESearchStatus = {}));

/**
 * 打开应用入口可见
 * 1、应用是启用状态
 * 2、配置了主页地址
 * 3、- 基础应用如日程、文档、工作台助手
 *    - 企业自建应用或开放平台应用，用户在可见范围
 */
const canOpenAppHomePage = ({ homePage, type, role, status, }) => {
    return (homePage.pcHomePage &&
        [ERobotType.CORP, ERobotType.OPEN, ERobotType.WOA, ERobotType.ISV, ERobotType.ISV_TEST].includes(type) &&
        role !== EAppRoleType.UNKNOWN &&
        status === EAppRobotStatus.OPEN);
};
function getUser(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data: { users }, } = yield getContacts([id.toString()]);
        const { name, userid, avatar } = users[0];
        return { name, userid, avatar };
    });
}
/**
 * 发送消息入口可见
 * 1、企业自建应用或官方应用
 * 2、应用是启用状态
 * 3、用户在可见范围
 */
const canSendMessage = ({ type, role, status, }) => [ERobotType.CORP, ERobotType.WOA].includes(type) &&
    role !== EAppRoleType.UNKNOWN &&
    status === EAppRobotStatus.OPEN;
// 获取群聊机器人信息
function GetGroupRobotDetail({ chatid, robotid, status = ESearchStatus.ADDED, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getGroupRobotDetail(chatid, robotid, status);
        return data;
    });
}
// 获取单聊机器人信息
function GetSingleRobotInfo(chatid) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getSingleRobotInfo(chatid);
        const robotInfo = data.appRobot;
        if (robotInfo.ownerId) {
            robotInfo.owner = yield getUser(robotInfo.ownerId);
        }
        // 兼容方案，统一type
        robotInfo.type = robotInfo.typeInt;
        return robotInfo;
    });
}
// 获取机器人卡片数据信息
function GetUserCardRobotData(payloay) {
    return __awaiter(this, void 0, void 0, function* () {
        const { chatid, robotid, robotType } = payloay;
        const robotData = {};
        if (robotType === EChatRobotType.SINGLE) {
            // 单聊机器人
            const data = yield GetSingleRobotInfo(chatid);
            robotData.userid = data.robotid;
            robotData.name = data.name;
            robotData.avatar = data.avatars[0];
            robotData.robotInfo = {
                appid: data.appid,
                name: data.name,
                avatar: data.avatars[0],
                desc: data.desc,
                robotid: data.robotid,
                homePage: data.homePage,
                owner: data.owner,
                status: data.status,
                type: data.type,
                role: data.role,
                corpName: data.corpName,
                partnerApp: data.partnerApp,
            };
        }
        else if (robotType === EChatRobotType.GROUP) {
            // 群聊机器人
            const data = yield GetGroupRobotDetail({ chatid, robotid, status: ESearchStatus.ADDED });
            robotData.userid = data.robotid;
            robotData.name = data.name;
            robotData.avatar = data.avatar;
            // 机器人卡片默认值
            robotData.robotInfo = {
                name: data.name,
                avatar: data.avatar,
                desc: data.desc,
                robotid: data.robotid,
                status: 0,
                type: ERobotType.DEFAULT,
                role: EAppRoleType.UNKNOWN,
                homePage: {
                    pcHomePage: '',
                    mobileHomePage: '',
                    pcOpenMode: EAppOpenType.OUTSIDE,
                },
            };
            if (data.type === EGroupRobotType.APP) {
                // 应用机器人
                const { appId, ownerId, ownerName, status, type, role, homePageObject, partnerApp, corpName } = data.info;
                const robotInfo = robotData.robotInfo;
                robotInfo.robotType = EGroupRobotType.APP;
                robotInfo.appid = appId;
                robotInfo.status = status;
                robotInfo.type = type;
                robotInfo.role = role;
                robotInfo.homePage = homePageObject;
                robotInfo.corpName = corpName;
                robotInfo.partnerApp = partnerApp;
                robotInfo.owner = {
                    userid: ownerId,
                    name: ownerName,
                    avatar: '',
                };
            }
            else if ([EGroupRobotType.WEBHOOK, EGroupRobotType.DUTY].includes(data.type)) {
                // webhook机器人和值班机器人取添加者
                robotData.robotInfo.owner = {
                    userid: data.creatorId,
                    name: data.creator,
                    avatar: '',
                };
                robotData.robotInfo.robotType =
                    data.type === EGroupRobotType.WEBHOOK ? EGroupRobotType.WEBHOOK : EGroupRobotType.DUTY;
            }
            else if (data.type === EGroupRobotType.HELPDESK) {
                // 服务台机器人
                robotData.robotInfo.robotType = EGroupRobotType.HELPDESK;
            }
        }
        return robotData;
    });
}

let UserCardRobot = class UserCardRobot extends Mixins(UserCardMixin$1, Locale) {
    constructor() {
        super(...arguments);
        this.options = this.propData;
    }
    get robotInfo() {
        return this.cardData.robotInfo;
    }
    get robotCreator() {
        // 应用没有拥有者时，即根据type来显示应用来源
        const type = this.robotInfo.type;
        let creator = '';
        switch (type) {
            case ERobotType.CORP:
                creator = this.t('personal_card_robot_corp_app');
                break;
            case ERobotType.OPEN:
                creator = this.t('personal_card_robot_open_plate_app');
                break;
            case ERobotType.WOA:
                creator = this.t('personal_card_robot_corp_app');
                break;
            case ERobotType.SUBSCRIPTION:
                creator = this.t('personal_card_robot_team_id');
                break;
            case ERobotType.ISV:
                creator = this.robotInfo.corpName || this.t('personal_card_robot_isv');
                break;
            case ERobotType.ISV_TEST:
                creator = this.robotInfo.corpName || this.t('personal_card_robot_isv');
                break;
        }
        return creator;
    }
    get showSendAppMsg() {
        var _a;
        const { type, role, status } = this.robotInfo;
        return ((_a = this.options) === null || _a === void 0 ? void 0 : _a.robotType) === EChatRobotType.GROUP && canSendMessage({ type, role, status });
    }
    get showOpenApp() {
        const { homePage, type, role, status } = this.robotInfo;
        return canOpenAppHomePage({ homePage, type, role, status });
    }
    get openAppBtnProps() {
        if (this.showOpenApp && this.showSendAppMsg) {
            return {};
        }
        else {
            return {
                type: 'primary',
            };
        }
    }
    // 是否团队号
    get isSubscription() {
        return this.robotInfo.type === ERobotType.SUBSCRIPTION;
    }
    get roleName() {
        return this.isSubscription
            ? this.t('personal_card_robot_responser')
            : this.t('personal_card_robot_developer');
    }
    // 服务台
    get isHelpdesk() {
        return this.robotInfo.robotType == EGroupRobotType.HELPDESK;
    }
    handleAvatarClick() {
        this.$emit('onClickAvatar');
    }
};
__decorate([
    Prop()
], UserCardRobot.prototype, "cardData", void 0);
__decorate([
    Inject()
], UserCardRobot.prototype, "propData", void 0);
UserCardRobot = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}UserCardRobot`,
        data() {
            return {
                ERobotType,
            };
        },
    })
], UserCardRobot);
var script$5 = UserCardRobot;

/* script */
const __vue_script__$5 = script$5;
/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "woa-user-card-robot electron-no-drag" }, [
    _c(
      "div",
      { staticClass: "card-header" },
      [
        _vm.cardData.avatar
          ? _c("img", {
              key: _vm.cardData.avatar,
              staticClass: "header-avatar electron-no-drag",
              attrs: { src: _vm.cardData.avatar, draggable: "false" },
              on: {
                click: function ($event) {
                  return _vm.handleAvatarClick(_vm.cardData.avatar)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("WoaRobotName", {
          staticClass: "robot-name",
          attrs: {
            text: _vm.cardData.name,
            "show-icon": !_vm.isSubscription,
            "partner-app": _vm.robotInfo.partnerApp,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-main" },
      [
        _c("div", { staticClass: "name" }, [
          _vm._v(_vm._s(_vm.t("personal_card_robot_desc"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.robotInfo.desc)),
        ]),
        _vm._v(" "),
        _vm.robotInfo.partnerApp && _vm.robotInfo.corpName
          ? [
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.t("personal_card_robot_own_corp"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.robotInfo.corpName)),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.isHelpdesk
          ? _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.roleName))])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isHelpdesk
          ? _c("div", { staticClass: "value" }, [
              [_vm.ERobotType.ISV, _vm.ERobotType.ISV_TEST].includes(
                _vm.robotInfo.type
              )
                ? _c("span", [_vm._v(_vm._s(_vm.robotCreator))])
                : _vm.robotInfo.owner && _vm.robotInfo.owner.name
                ? _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("onSendMsg", _vm.robotInfo.owner)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.robotInfo.owner.name))]
                  )
                : _c("span", [_vm._v(_vm._s(_vm.robotCreator))]),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.showOpenApp || _vm.showSendAppMsg
      ? _c(
          "div",
          { staticClass: "card-footer" },
          [
            _vm.showOpenApp
              ? _c(
                  "el-button",
                  _vm._b(
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("onOpenRobotApp")
                        },
                      },
                    },
                    "el-button",
                    _vm.openAppBtnProps,
                    false
                  ),
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.t("personal_card_robot_open_app")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showSendAppMsg
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onSendMsg")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.t("personal_card_send_message")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = "data-v-c9492898";
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

let DialogWrapper = class DialogWrapper extends Vue$1 {
};
DialogWrapper = __decorate([
    Component({
        inheritAttrs: false,
        components: {
            KdDialog: Dialog$1,
        },
    })
], DialogWrapper);
var script$4 = DialogWrapper;

/* script */
const __vue_script__$4 = script$4;
/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "kd-dialog",
    _vm._g(
      _vm._b(
        { staticClass: "xz-dialog-wrapper" },
        "kd-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = "data-v-353849e8";
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

class Dialog {
    constructor(_options) {
        this._options = _options;
    }
    get visible() {
        var _a;
        return !!((_a = this._vm) === null || _a === void 0 ? void 0 : _a.$props.visible);
    }
    show(options) {
        const vm = this._toggle(true);
        vm && options && assign(vm.$props, options);
    }
    close() {
        this._toggle(false);
    }
    _toggle(visible) {
        if (visible === this.visible) {
            return this._vm;
        }
        const vm = this._render();
        vm.$props.visible = visible;
        if (!visible && this._options.destroyOnClose) {
            vm.$once('closed', () => this._destroy());
        }
        return this._vm;
    }
    _destroy() {
        if (!this._vm) {
            return;
        }
        this._vm.$destroy();
        this._vm = void 0;
    }
    _render() {
        if (this._vm) {
            return this._vm;
        }
        const _a = this._options, { component } = _a, props = __rest(_a, ["component"]);
        const updateVisible = this._toggle.bind(this);
        const Dialog = Vue.extend({
            props: {
                title: { type: String, default: props.title },
                visible: { type: Boolean, default: false },
                args: { type: undefined, default: null },
            },
            render(h) {
                return h(__vue_component__$4, {
                    attrs: Object.assign(Object.assign({}, props), { appendToBody: true, destroyOnClose: false, visible: this.visible, title: this.title }),
                    on: { 'update:visible': updateVisible, closed: () => this.$emit('closed') },
                }, [h(component, { props: { args: this.args }, on: { close: () => updateVisible(false) } })]);
            },
        });
        this._vm = new Dialog().$mount();
        return this._vm;
    }
}

let EmbedIframe = class EmbedIframe extends Vue$1 {
    constructor() {
        super(...arguments);
        this.isLoading = true;
    }
    get loading() {
        return this.withLoading && this.isLoading;
    }
    created() {
        this.setupMessageEvent();
    }
    setupMessageEvent() {
        const onMessage = (e) => {
            var _a;
            e.source && e.source === ((_a = this.$iframe) === null || _a === void 0 ? void 0 : _a.contentWindow) && this.$emit('message', e);
        };
        window.addEventListener('message', onMessage, true);
        this.$once('hook:beforeDestroy', () => window.removeEventListener('message', onMessage, true));
    }
    onLoad() {
        this.isLoading = false;
    }
    reset() {
        var _a;
        (_a = this.$iframe) === null || _a === void 0 ? void 0 : _a.setAttribute('src', this.src);
    }
};
__decorate([
    Prop()
], EmbedIframe.prototype, "src", void 0);
__decorate([
    Prop({ default: 'no' })
], EmbedIframe.prototype, "scrolling", void 0);
__decorate([
    Prop({ default: false })
], EmbedIframe.prototype, "withLoading", void 0);
__decorate([
    Ref()
], EmbedIframe.prototype, "$iframe", void 0);
EmbedIframe = __decorate([
    Component
], EmbedIframe);
var script$3 = EmbedIframe;

/* script */
const __vue_script__$3 = script$3;
/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "embed-iframe",
    },
    [
      _c(
        "iframe",
        _vm._b(
          {
            ref: "$iframe",
            staticClass: "embed-iframe-inner",
            style: { visibility: _vm.loading ? "hidden" : "visible" },
            attrs: {
              src: _vm.src,
              frameborder: "0",
              scrolling: _vm.scrolling,
              seamless: "seamless",
            },
            on: { load: _vm.onLoad },
          },
          "iframe",
          _vm.$attrs,
          false
        )
      ),
    ]
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = "data-v-10cb3e5d";
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

let NetworkError = class NetworkError extends Vue$1 {
    reload() {
        this.$emit('reload');
    }
};
__decorate([
    Prop({ default: '' })
], NetworkError.prototype, "title", void 0);
__decorate([
    Prop({ default: '网络异常，请检查网络设置' })
], NetworkError.prototype, "desc", void 0);
__decorate([
    Prop({ default: true })
], NetworkError.prototype, "reloadBtnShow", void 0);
NetworkError = __decorate([
    Component({
        components: {
            KdButton: Button$1,
        },
    })
], NetworkError);
var script$2 = NetworkError;

var __$_require_assets_img_network_error_svg__ = "assets/img/network-error.svg";

/* script */
const __vue_script__$2 = script$2;
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "error-wrap" }, [
    _c(
      "div",
      { staticClass: "error-wrap__item" },
      [
        _vm._t("network-error-icon", [
          _c("img", {
            attrs: {
              src: __$_require_assets_img_network_error_svg__,
              width: "100",
              height: "100",
              draggable: "false",
            },
          }),
        ]),
        _vm._v(" "),
        _vm.title
          ? _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
          : _vm._e(),
        _vm._v(" "),
        _c("pre", { staticClass: "desc" }, [
          _vm._v(" " + _vm._s(_vm.desc) + " "),
        ]),
        _vm._v(" "),
        _vm.reloadBtnShow
          ? _c(
              "kd-button",
              {
                staticClass: "reload-btn",
                attrs: { type: "primary" },
                on: { click: _vm.reload },
              },
              [_vm._v(" 重新加载 ")]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = "data-v-58312ffa";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

let NetworkManager = class NetworkManager extends Vue$1 {
    constructor() {
        super(...arguments);
        this.online = navigator.onLine;
    }
    created() {
        this.setupOnlineListener();
    }
    setupOnlineListener() {
        const update = () => (this.online = navigator.onLine);
        window.addEventListener('online', update);
        window.addEventListener('offline', update);
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('online', update);
            window.removeEventListener('offline', update);
        });
    }
};
NetworkManager = __decorate([
    Component
], NetworkManager);
var NetworkManager$1 = NetworkManager;

let IframeDialog = class IframeDialog extends Mixins(NetworkManager$1) {
    get url() {
        var _a;
        return (_a = this.args) === null || _a === void 0 ? void 0 : _a.url;
    }
    onMessage(e) {
        var _a, _b;
        (_b = (_a = this.args) === null || _a === void 0 ? void 0 : _a.onMessage) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    }
};
__decorate([
    Prop()
], IframeDialog.prototype, "args", void 0);
IframeDialog = __decorate([
    Component({
        components: { EmbedIframe: __vue_component__$3, NetworkError: __vue_component__$2 },
    })
], IframeDialog);
var script$1 = IframeDialog;

/* script */
const __vue_script__$1 = script$1;
/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.online && _vm.url
    ? _c("embed-iframe", {
        attrs: { src: _vm.url },
        on: { message: _vm.onMessage },
      })
    : _c("network-error", {
        staticClass: "error",
        attrs: { "reload-btn-show": false },
      })
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = "data-v-4a3a2848";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

const iframeDialog = new Dialog({
    component: __vue_component__$1,
    customClass: 'iframe-dialog woa-user-card',
    closeOnClickModal: false,
    destroyOnClose: true,
});

const openChat = (uid) => {
    window.open(`ksoxz://xz.wps.cn/chat?xz_user_id=${uid}`);
};

let UserCard = class UserCard extends Mixins(Locale) {
    constructor() {
        super(...arguments);
        this.propData = this.options;
        this.loading = true;
        this.isSubPopperVisible = false;
        this.userCardCompMap = {
            [EUserCardType.NORMAL]: __vue_component__$6,
            [EUserCardType.ROBOT]: __vue_component__$5,
        };
    }
    get getOrigin() {
        return this.options.xOrigin;
    }
    get userCardComp() {
        return this.options.cardType && this.userCardCompMap[this.options.cardType];
    }
    get hasCardData() {
        return Object.keys(this.cardData).length !== 0;
    }
    beforeCreate() {
        const lang = getLang();
        try {
            if (lang) {
                const localeFile = langMap[lang];
                locale$1.use(localeFile);
            }
        }
        catch (error) {
            console.error('Can not find locale with cookie key.', error);
        }
    }
    onEnvLoad() {
        this.loading = false;
        this.renderContent();
    }
    renderContent() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            // 如果有外部自定义数据，可以直接同步渲染
            if (this.options.cardData) {
                this.cardData = this.options.cardData;
                yield this.$nextTick();
                this.onOpenPopper && this.onOpenPopper();
                return;
            }
            const cardData = yield this.getCardData();
            if (cardData) {
                if (this.options.cardType === EUserCardType.NORMAL) {
                    const { chatData } = cardData;
                    // 这里要更新用户本地缓存
                    (_b = (_a = this.options).onUpdateUserInfo) === null || _b === void 0 ? void 0 : _b.call(_a, cardData);
                    if (chatData === null || chatData === void 0 ? void 0 : chatData.nickname) {
                        // 这里更新群昵称
                        (_d = (_c = this.options).onSetGroupNickname) === null || _d === void 0 ? void 0 : _d.call(_c, cardData);
                    }
                }
                else if (this.options.cardType === EUserCardType.ROBOT) {
                    this.options.onUpdateRobotInfo && this.options.onUpdateRobotInfo(cardData);
                }
                this.cardData = Object.assign({}, cardData);
                yield this.$nextTick();
                this.onOpenPopper && this.onOpenPopper();
                // 这里创建成功有埋点 chat_msgbox_msglist_show
                const { chatid, chatType } = this.options;
                chatid &&
                    onChatMsgboxMsglistShow(toSnakeCase({
                        chatId: chatid,
                        name: this.cardData.name,
                        chatType: chatType,
                        msgCard: 'true',
                        time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    }));
            }
            if (this.options.xOrigin) {
                const { data } = yield getOrganizationTypeTextFromRemote();
                setOrganizationTypeText(data.copywriting);
            }
        });
    }
    /**
     * @description 获取卡片展示信息
     */
    getCardData() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let cardData;
            const { cardType, userid, robotType, searchChat, chatType, chatid, wpsUid, corpid } = this.options;
            try {
                // 获取用户信息
                if (cardType === EUserCardType.NORMAL) {
                    const params = toSnakeCase({
                        userid: userid || wpsUid,
                        idType: userid ? EUseridType.WOA : EUseridType.WPS,
                        chatId: chatType === EChatType.GROUP ? chatid : void 0,
                    });
                    ({ data: cardData } = yield getBusinessCardData(params));
                    // 获取直属上级姓名
                    if ((cardData === null || cardData === void 0 ? void 0 : cardData.leader) && cardData.leader !== '0') {
                        const { data } = yield getUserNameByWpsuid(cardData.leader);
                        cardData.leaderName = data.userName;
                    }
                }
                // 获取机器人信息
                if (cardType === EUserCardType.ROBOT) {
                    // 规则：传入的 > 搜索对象 > ChatModule.currentChatId
                    // 团队广场没有currentChatId，需要外部传入
                    const chatid = this.options.chatid
                        ? this.options.chatid
                        : searchChat
                            ? searchChat.id
                            : this.options.chatid; //原本通过会话模块获取当前会话id
                    cardData = yield GetUserCardRobotData({
                        chatid: chatid,
                        robotid: userid,
                        robotType: robotType,
                    });
                }
                return cardData;
            }
            catch (error) {
                if (this.options.onError) {
                    this.options.onError(((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || error);
                }
                else {
                    toast.errorResponse(error);
                }
                this.closeUserCardPopper();
            }
        });
    }
    // 查看日程
    checkBusyStatus() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onClickSchedule) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
        });
    }
    // 发送消息的逻辑处理
    onSendMsg(owner) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.onClickSendMsg) {
                (_b = (_a = this.options).onClickSendMsg) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData, owner);
            }
            else {
                openChat(this.cardData.userid);
                this.closeUserCardPopper();
            }
            reportMsgClickUserCard('send');
        });
    }
    // 打开编辑个人状态
    onClickWorkStatus() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onClickWorkStatus) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
            // 编辑状态埋点
            reportMsgClickUserCard('workstatus');
        });
    }
    // 语音通话
    startVoiceCall() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onStartVoiceCall) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
        });
    }
    // 建立会议
    onJoinMeeting() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onJoinMeeting) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
        });
    }
    // 打开机器人应用
    onOpenRobotApp() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onOpenRobotApp) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
            // 打开机器人这里有埋点 ChatMsgboxMsglistClick
            onChatMsgboxMsglistClick(toSnakeCase({
                chatId: (_c = this.options) === null || _c === void 0 ? void 0 : _c.chatid,
                name: this.cardData.name,
                chatType: EChatSidebarType.ROBOT,
                toappFrom: 'msg_card',
            }));
        });
    }
    // 申请添加联系人
    onDidApplyExtContact() {
        return __awaiter(this, void 0, void 0, function* () {
            const { channel, onClickApplyExtContact } = this.options;
            const prevented = yield (onClickApplyExtContact === null || onClickApplyExtContact === void 0 ? void 0 : onClickApplyExtContact(this.cardData));
            if (prevented) {
                return;
            }
            const { userid, corpid } = this.cardData;
            const url = new URL(g.serviceURL(SVR.WOA) + EXT_CONTACT_INVITE_PATH);
            url.searchParams.set('dialog', 'true');
            url.searchParams.set('origin', 'user_card');
            url.searchParams.set('userid', userid.toString());
            url.searchParams.set('corpid', corpid.toString());
            channel && url.searchParams.set('channel', channel);
            this.closeUserCardPopper();
            iframeDialog.show({
                title: this.t('personal_card_add_contact'),
                args: {
                    url: url.toString(),
                    onMessage: (e) => {
                        var _a, _b, _c;
                        const action = (_a = e.data) === null || _a === void 0 ? void 0 : _a.action;
                        if (!action) {
                            return;
                        }
                        switch (action) {
                            case 'winClose':
                                iframeDialog.close();
                                break;
                            case 'copyText':
                                const text = (_c = (_b = e.data) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.contactCopyText;
                                text && this.copyText(text);
                                break;
                        }
                    },
                },
            });
        });
    }
    copyText(text) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield copyToClipboard(text);
                toast.success('复制链接成功');
            }
            catch (e) {
                console.error(e);
                toast.error('复制链接失败');
            }
        });
    }
    onClickAvatar() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            (_b = (_a = this.options).onClickAvatar) === null || _b === void 0 ? void 0 : _b.call(_a, this.cardData);
        });
    }
    onOpenUrl(url) {
        var _a, _b;
        (_b = (_a = this.options).onOpenUrl) === null || _b === void 0 ? void 0 : _b.call(_a, url);
    }
    onOpenDept(deptIndex) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { onOpenDept } = this.options;
            // 因为组件显示时对 departments 数据做了处理，只显示了 name，点击时，根据 index 从原始数据中获取完整的部门信息
            const userCardData = this.cardData;
            const deptInfo = (_a = userCardData.departments) === null || _a === void 0 ? void 0 : _a[deptIndex];
            // 类型定义已经确定参数为 undefined 或者 function，因此这里仅判断是否为 undefined
            onOpenDept && onOpenDept(deptInfo, userCardData);
        });
    }
    /**
     * @description 关闭主 popper
     */
    closeUserCardPopper() {
        var _a, _b;
        userCardPopper.close();
        (_b = (_a = this.options).onHandleTriggerClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    /**
     * @description 关闭子 popper
     */
    closeSubPopper() {
        var _a;
        const childComp = this.$userNormalCard;
        (_a = childComp === null || childComp === void 0 ? void 0 : childComp.closeSubPopper) === null || _a === void 0 ? void 0 : _a.call(childComp);
    }
};
__decorate([
    Prop()
], UserCard.prototype, "options", void 0);
__decorate([
    Prop()
], UserCard.prototype, "onOpenPopper", void 0);
__decorate([
    Provide()
], UserCard.prototype, "propData", void 0);
__decorate([
    Ref()
], UserCard.prototype, "$userNormalCard", void 0);
UserCard = __decorate([
    Component({
        name: `${NAMESPACE_PREFIX}UserCard`,
        components: {
            UserCardNormal: __vue_component__$6,
            UserCardRobot: __vue_component__$5,
            [__vue_component__$b.extendOptions.name]: __vue_component__$b,
        },
        data() {
            return {
                cardData: {},
            };
        },
    })
], UserCard);
var script = UserCard;

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "woa-env",
    { attrs: { "x-origin": _vm.getOrigin }, on: { loaded: _vm.onEnvLoad } },
    [
      !_vm.loading && _vm.hasCardData
        ? _c(
            "div",
            { staticClass: "woa-user-card woa-theme-wrapper" },
            [
              _c(_vm.userCardComp, {
                tag: "component",
                attrs: { "card-data": _vm.cardData },
                on: {
                  checkBusyStatus: _vm.checkBusyStatus,
                  onSendMsg: _vm.onSendMsg,
                  onStartVoiceCall: _vm.startVoiceCall,
                  onJoinMeeting: _vm.onJoinMeeting,
                  onOpenRobotApp: _vm.onOpenRobotApp,
                  onDidApplyExtContact: _vm.onDidApplyExtContact,
                  onClickWorkStatus: _vm.onClickWorkStatus,
                  onClickAvatar: _vm.onClickAvatar,
                  onOpenDept: _vm.onOpenDept,
                  onOpenUrl: _vm.onOpenUrl,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-05097714";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

Vue.component(`WoaVueContext`, WoaVueContext);
Vue.use(AmIcon);
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 999999,
    },
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': __vue_component__
});

__vue_component__.install = function (Vue) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (opts.locale) {
    locale$1.use(opts.locale);
    setLang('');
  } else {
    setLang(opts.lang);
  }
  locale$1.i18n(opts.i18n);
  Vue.component(__vue_component__.extendOptions.name, __vue_component__);
  Vue.prototype.$userCardPopper = userCardPopper;
};

export { __vue_component__ as default, userCardPopper, setLang as userCardSetLang };
